var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDepartingTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 560,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F9",
    fillRule: "evenodd",
    d: "M555.396 139.737C527.32 43.023 317.07-2.08 206.728.074 101.065 2.136 20.218 37.634 1.484 145.538-23.668 290.409 278.206 225.6 359.4 225.249c73.495 2.243 229.298 29.206 195.995-85.512Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 560,
    height: 240,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M555.396 139.737C527.32 43.023 317.07-2.08 206.728.074 101.065 2.136 20.218 37.634 1.484 145.538-23.668 290.409 278.206 225.6 359.4 225.249c73.495 2.243 229.298 29.206 195.995-85.512Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M537.807 191.565s-123.022 25.032-233.345 30.043c-110.322 5.012-273.646 3.389-273.646 3.389l-45.124-34.213s409.529 9.208 489.749.781c.025.019 62.366 0 62.366 0Z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M478.814 184.476h24.335l-.091-8.869h-24.335l.091 8.869Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M448.794 179.653c-2.474.126-4.431 4.416-4.372 9.58.06 5.167 2.115 9.252 4.589 9.127h4.486l-.519-11.413-4.184-7.294Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M458.441 188.778c-.061-5.164-2.115-9.251-4.589-9.125-2.474.126-4.431 4.416-4.371 9.58.06 5.167 2.115 9.252 4.588 9.127 2.474-.126 4.431-4.416 4.372-9.582ZM474.743 179.893c-2.474.126-4.431 4.415-4.372 9.58.061 5.167 2.115 9.252 4.589 9.127h4.486l-.518-11.413-4.185-7.294Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#354242",
    fillRule: "evenodd",
    d: "M484.39 189.018c-.06-5.164-2.115-9.251-4.589-9.125-2.473.126-4.431 4.415-4.371 9.58.061 5.167 2.115 9.252 4.588 9.127 2.475-.126 4.431-4.416 4.372-9.582Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M481.239 166.522h24.557l-5.83-31.512-18.727-.025v31.537Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M500.109 149.118v-12.904c0-1.144-.837-1.21-.837-1.21h.829s14.335.663 14.329 9.566c-.004 5.366-5.144 6.381-5.144 6.381l-9.177-1.833Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M500.109 142.38v6.59h13.762c-.38-4.364-.145-6.59-2.096-6.59h-11.666Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M481.526 175.658h24.557l-3.112-31.536c.328 0-21.756 0-21.445-.001v31.537Z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M485.361 178.067h19.697l1.686 4.106h-22.366l.983-4.106Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M479.319 179.857c-2.474.126-4.431 4.415-4.371 9.581.059 5.166 2.115 9.251 4.588 9.126h4.279l-4.496-18.707ZM505.598 179.857c-2.473.126-4.431 4.415-4.371 9.581.06 5.166 2.115 9.251 4.588 9.126h4.215l-4.432-18.707Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M502.971 175.658h4.069v-31.089h-4.069v31.089Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M515.719 178.577h3.146v-3.978h-3.146v3.978Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M473.384 176.988h10.328l2.995 3.826h34.061l-6.839 10.006h-48.955v-10.006l8.41-3.826Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M492.603 189.007h-1.879l-.492-2.271v-5.922h2.371v8.193Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M505.605 144.536v33.076l14.671 3.284 1.132-1.482c.002-.714.005-1.221.005-3.405 0-2.198-.091-4.78-.263-7.499l-.04-.609-1.67-13.785.283-1.862c-.398-4.204-1.86-6.69-3.046-6.985-3.457-.86.55-.733-11.072-.733Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m518.991 155.083.426 4.817.647 7.332c.047.546.182.917.445 1.026.264.109.641.252.641.252-.012-.202-.026-.406-.04-.61l-.383-4.309-.838-9.459-.001-.008h-.644c-.197 0-.306.363-.253.959Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M521.186 172.023c.688 0 1.252.564 1.252 1.251v4.906c0 .688-.564 1.251-1.252 1.251h-.321c-.689 0-1.792-.162-2.45-.359l-1.748-.525c-.66-.199-1.199-.923-1.199-1.612v-3.661c0-.687.563-1.251 1.251-1.251h4.467Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M505.518 150.266v-.616s14.647.185 14.596-.466c.213 1.591.855 3.602 1.059 5.765h-2.182l-.306-3.079-13.167-1.604Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M519.136 179.41v-7.547c0-1.101-.077-2.901-.17-3.998l-1.157-13.614c-.093-1.098-1.07-1.996-2.171-1.996h-7.906a2.008 2.008 0 0 0-2.002 2.002v24.32",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M510.306 155.242v8.059c0 .625-.482.964-1.07.751l-1.359-.481c-.588-.213-1.07-.895-1.07-1.519v-6.728c0-.624.514-1.147 1.139-1.163l1.224-.029c.287-.004.548.094.748.265.237.205.388.507.388.845ZM517.658 165.465c.046.583-.359.886-.906.669l-3.299-1.306c-.335-.135-.632-.432-.812-.784a1.461 1.461 0 0 1-.179-.674v-8.18c0-.588.481-1.066 1.065-1.066h2.139c.587 0 1.102.478 1.151 1.062l.294 3.616.547 6.663Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#006E17",
    d: "M511.4 152.255v23.403"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M502.971 174.837v.853h7.512c1.485 0 2.885 1.604 3.946 3.772.211.432.403.892.577 1.379h.735a15.371 15.371 0 0 0-.889-2.28c-1.174-2.403-2.725-3.724-4.369-3.724h-7.512Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M508.399 180.878h-12.493v-2.269l16.331 1.246 2.533-.445h6.612v1.468h-12.983Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M505.128 189.209a26.438 26.438 0 0 0 .035 1.32h1.386a13.99 13.99 0 0 1-.025-.462 19.03 19.03 0 0 1 .096-2.97c.301-2.725 1.173-4.998 2.339-6.234h-2.249c-.762 1.698-1.294 3.849-1.495 6.234a25.532 25.532 0 0 0-.087 2.112Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M521.295 180.863c.688 0 1.251.563 1.251 1.251v8.194c0 .688-.563 1.252-1.251 1.252h-7.806a1.256 1.256 0 0 1-1.252-1.252v-8.194c0-.688.563-1.251 1.252-1.251h7.806Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M516.984 187.737c-.21-2.511-.672-5.186-1.474-6.972h-9.304c-1.035 6.631-2.515 9.418-2.515 9.418s2.288 1.324 2.284 1.372h11.065c.006-.119.011-.443.017-.565a26.436 26.436 0 0 0-.073-3.253Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M501.682 144.104h16.562c2.098 0 2.008 3.041 2.485 8.084h-17.758v-5.777c0-2.344-1.289-2.307-1.289-2.307Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M506.906 176.985c-2.884-.146-5.338 4.107-5.885 9.819a24.385 24.385 0 0 0-.112 2.108c-.005.445.002 1.437.019 1.872h4.389l4.686-5.628V177l-3.097-.015Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M487.527 180.708c-.876-1.361-1.967-2.962-3.141-2.902-1.173.059-2.96 1.77-3.804 3.217-1.166 2-1.896 5.058-1.857 8.443.005.448.014 1.72.044 2.149l1.192-.06c-.04-.427-.052-1.699-.057-2.149-.052-4.477 1.651-8.207 3.795-8.317 2.145-.108 3.933 3.445 3.985 7.923.005.449-.008.891-.037 1.322l1.908-.061c.021-.432.029-.874.024-1.321-.039-3.385-.84-6.365-2.052-8.244Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M488.679 188.983c-.06-5.165-2.115-9.251-4.589-9.126-2.473.126-4.43 4.416-4.37 9.58.06 5.166 2.115 9.253 4.588 9.127 2.474-.126 4.431-4.415 4.371-9.581Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M484.282 196.28c-1.867.095-3.423-3-3.468-6.899-.045-3.897 1.437-7.145 3.303-7.239 1.867-.096 3.423 2.999 3.469 6.896.045 3.898-1.437 7.148-3.304 7.242Z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1EBFF",
    fillRule: "evenodd",
    d: "M484.271 195.321c-1.614.081-2.958-2.593-2.998-5.962-.039-3.369 1.242-6.176 2.855-6.259 1.614-.081 2.959 2.593 2.998 5.962.039 3.369-1.242 6.177-2.855 6.259Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8AEB3",
    fillRule: "evenodd",
    d: "M486.671 189.086c.006.514-.024 1.011-.088 1.481-.212 1.589-.786 2.872-1.53 3.42a1.372 1.372 0 0 1-.751.287 1.271 1.271 0 0 1-.754-.211c-.746-.463-1.345-1.659-1.599-3.196-.08-.482-.126-.997-.132-1.535a10.17 10.17 0 0 1 .096-1.547c.22-1.574.797-2.835 1.539-3.369.23-.166.476-.262.733-.275.257-.014.504.058.738.201.764.463 1.376 1.691 1.625 3.271.074.463.117.959.123 1.473Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1EBFF",
    fillRule: "evenodd",
    d: "M486.478 189.134a6.52 6.52 0 0 1-.053.898c-.129.962-.477 1.739-.928 2.071a.827.827 0 0 1-.454.175.792.792 0 0 1-.458-.128c-.451-.281-.814-1.005-.968-1.936a5.99 5.99 0 0 1-.08-.932 6.16 6.16 0 0 1 .058-.936c.133-.954.482-1.718.932-2.041a.83.83 0 0 1 .444-.168.78.78 0 0 1 .448.123c.463.28.833 1.025.984 1.982.045.28.071.581.075.892Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M485.626 189.181c.002.131-.006.257-.022.376-.054.405-.2.731-.389.869a.352.352 0 0 1-.192.073.323.323 0 0 1-.192-.054c-.19-.118-.343-.423-.408-.815a2.66 2.66 0 0 1-.008-.784c.056-.4.202-.72.391-.855a.346.346 0 0 1 .187-.07.328.328 0 0 1 .188.051c.195.119.35.432.414.834.018.118.03.244.031.375Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M486.548 187.613c-.25-1.579-.86-2.808-1.625-3.271a1.274 1.274 0 0 0-.738-.202c-.257.014-.503.11-.733.277-.742.532-1.318 1.793-1.539 3.369a10.544 10.544 0 0 0-.097 1.546v.002l.454-.023v-.001a8.49 8.49 0 0 1 .078-1.258c.179-1.282.648-2.307 1.251-2.74.187-.138.388-.214.597-.225.208-.01.411.047.601.164.621.375 1.117 1.375 1.321 2.659.059.378.094.781.099 1.199v.002l.454-.023v-.003a10.25 10.25 0 0 0-.123-1.472Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M489.609 186.805c-.547-5.713-3.002-9.967-5.886-9.82-2.884.146-5.236 4.643-5.65 10.405a25.371 25.371 0 0 0-.013 3.434l.791-.04c-.03-.43-.05-.87-.054-1.318-.04-3.386.691-6.443 1.856-8.443.844-1.446 1.915-2.337 3.09-2.396 1.174-.06 2.264.72 3.14 2.081 1.212 1.879 2.012 4.858 2.052 8.244.005.448-.003.889-.023 1.322l-.596.03 1.386-.071a25.129 25.129 0 0 0-.093-3.428Z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4E3EC",
    fillRule: "evenodd",
    d: "M502.466 188.147c0 1.139-.931 2.07-2.071 2.07h-6.355a2.076 2.076 0 0 1-2.07-2.07v-6.802c0-1.139.932-2.07 2.07-2.07h6.355c1.14 0 2.071.931 2.071 2.07v6.802Z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#828DA9",
    fillRule: "evenodd",
    d: "M502.465 187.168v1.232c0 1.204-.046 1.817-.643 1.817h-9.092c-.418 0-.76-.818-.76-1.817v-1.232c0 1 .342 1.817.76 1.817h8.976c.418 0 .759-.817.759-1.817Z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#828DA9",
    fillRule: "evenodd",
    d: "M494.039 188.158c0 1.139-.869 2.07-1.932 2.07-1.062 0-1.931-.931-1.931-2.07v-6.803c0-1.138.869-2.07 1.931-2.07 1.063 0 1.932.932 1.932 2.07v6.803Z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M489.341 186.259c.117.903.907 1.641 1.755 1.641.848 0 1.542-.326 1.542-.725v-4.943a1.66 1.66 0 0 0-1.655-1.655h-.729c-.91 0-1.559.739-1.441 1.641l.528 4.041Z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M513.192 180.708c-.875-1.361-1.966-2.962-3.141-2.902-1.173.059-2.96 1.77-3.804 3.217-1.166 2-1.896 5.058-1.857 8.443.005.448.014 1.72.045 2.149l1.191-.06c-.04-.427-.051-1.699-.057-2.149-.052-4.477 1.651-8.207 3.795-8.317 2.145-.108 3.933 3.445 3.985 7.923.005.449-.049 1.33-.078 1.761l2.027.024c.02-.433-.049-1.398-.053-1.845-.04-3.385-.841-6.365-2.053-8.244Z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M514.177 188.983c-.06-5.165-2.114-9.251-4.588-9.126-2.474.126-4.431 4.416-4.371 9.58.06 5.166 2.115 9.253 4.589 9.127 2.474-.126 4.43-4.415 4.37-9.581Z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M509.78 196.28c-1.867.095-3.423-3-3.469-6.899-.044-3.897 1.437-7.145 3.304-7.239 1.867-.096 3.423 2.999 3.468 6.896.045 3.898-1.436 7.148-3.303 7.242Z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1EBFF",
    fillRule: "evenodd",
    d: "M509.769 195.321c-1.614.081-2.958-2.593-2.998-5.962-.039-3.369 1.242-6.176 2.855-6.259 1.614-.081 2.959 2.593 2.998 5.962.039 3.369-1.242 6.177-2.855 6.259Z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8AEB3",
    fillRule: "evenodd",
    d: "M512.169 189.086c.006.514-.024 1.011-.088 1.481-.212 1.589-.785 2.872-1.53 3.42a1.372 1.372 0 0 1-.751.287 1.271 1.271 0 0 1-.754-.211c-.746-.463-1.345-1.659-1.599-3.196-.08-.482-.126-.997-.132-1.535a10.3 10.3 0 0 1 .096-1.547c.22-1.574.796-2.835 1.539-3.369.23-.166.477-.262.733-.275.256-.014.504.058.739.201.764.463 1.375 1.691 1.624 3.271.074.463.117.959.123 1.473Z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M512.046 187.613c-.249-1.579-.86-2.808-1.625-3.271a1.277 1.277 0 0 0-.739-.202c-.256.014-.502.11-.732.277-.743.532-1.318 1.793-1.539 3.369a10.41 10.41 0 0 0-.096 1.546v.002l.453-.023v-.001a8.488 8.488 0 0 1 .079-1.258c.178-1.282.647-2.307 1.25-2.74.187-.138.388-.214.597-.225.209-.01.411.047.601.164.621.375 1.118 1.375 1.321 2.659.06.378.094.781.099 1.199v.002l.454-.023v-.003a10.108 10.108 0 0 0-.123-1.472Z",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M504.455 186.805c.548-5.713 3.002-9.967 5.886-9.82 2.884.146 5.236 4.643 5.65 10.405a25.371 25.371 0 0 1 .013 3.434l-.791-.04c.03-.43.05-.87.054-1.318.04-3.386-.69-6.443-1.856-8.443-.844-1.446-1.915-2.337-3.09-2.396-1.174-.06-2.263.72-3.14 2.081-1.212 1.879-2.012 4.858-2.052 8.244-.005.448-.012 1.46.009 1.892l-.792-.04a54.194 54.194 0 0 1-.003-1.892c.008-.721.046-1.425.112-2.107Z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1EBFF",
    fillRule: "evenodd",
    d: "M511.976 189.134c.003.311-.016.612-.054.898-.128.962-.476 1.739-.926 2.071a.83.83 0 0 1-.456.175.785.785 0 0 1-.456-.128c-.452-.281-.815-1.005-.968-1.936a6.112 6.112 0 0 1-.081-.932 6.16 6.16 0 0 1 .058-.936c.134-.954.483-1.718.932-2.041a.83.83 0 0 1 .445-.168.779.779 0 0 1 .447.123c.463.28.833 1.025.985 1.982.044.28.07.581.074.892Z",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M511.125 189.181c.001.131-.007.257-.023.376-.054.405-.2.731-.39.869a.321.321 0 0 1-.383.019c-.19-.118-.343-.423-.407-.815a2.412 2.412 0 0 1-.034-.391 2.5 2.5 0 0 1 .024-.393c.056-.4.203-.72.392-.855a.343.343 0 0 1 .187-.07.328.328 0 0 1 .188.051c.195.119.35.432.414.834.018.118.03.244.032.375Z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C4C",
    fillRule: "evenodd",
    d: "M364.191 184.113h3.514v-7.937h-3.514v7.937ZM412.589 173.725v7.017c0 .529.433.962.962.962h60.016a.964.964 0 0 0 .961-.962v-6.51",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4E3EC",
    fillRule: "evenodd",
    d: "M471.554 189.443c0 1.138-.932 2.07-2.07 2.07H455.4a2.077 2.077 0 0 1-2.07-2.07v-7.948c0-1.138.932-2.07 2.07-2.07h14.084c1.138 0 2.07.932 2.07 2.07v7.948Z",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M471.553 188.464v1.232c0 .999-.34 1.816-.758 1.816H454.09c-.418 0-.76-.817-.76-1.816v-1.232c0 1 .342 1.816.76 1.816h16.705c.418 0 .758-.816.758-1.816Z",
    clipRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M456.215 189.453a2.076 2.076 0 0 1-2.07 2.071h-.825a2.076 2.076 0 0 1-2.07-2.071v-7.946c0-1.14.931-2.071 2.07-2.071h.825c1.139 0 2.07.931 2.07 2.071v7.946Z",
    clipRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M450.042 185.902a1.66 1.66 0 0 0 1.655 1.654h1.124c.91 0 1.655-.326 1.655-.725v-9.089a1.66 1.66 0 0 0-1.655-1.654h-1.124a1.66 1.66 0 0 0-1.655 1.654v8.16Z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C4C",
    fillRule: "evenodd",
    d: "M449.919 175.928v5.485a1.66 1.66 0 0 0 1.654 1.655h1.284c.91 0 1.654-.326 1.654-.725V175.928",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m380.668 184.032-1.317 1.604-1.023-3.33-.88-2.859-1.598-5.205 1.318-1.61 1.459 4.755.833 2.714 1.208 3.931ZM393.978 184.032l-1.32 1.604-.876-2.851-.895-2.911-1.3-4.235-1.382 4.497-1.108 3.603-.584 1.897-1.317-1.604.905-2.95.977-3.183 1.617-5.267.892 1.086.889-1.086 1.557 5.07.837 2.723 1.108 3.607ZM420.173 174.242l-1.697 5.528-1.08 3.514-.723 2.352-1.32-1.604 1.001-3.262.966-3.144 1.536-4.994 1.317 1.61ZM408.252 184.032l-1.32 1.604-.898-2.929-.894-2.907-1.476-4.804-1.444 4.704-1.077 3.5-.748 2.436-1.32-1.604 1.02-3.319.965-3.142 1.518-4.939 1.086 1.325 1.086-1.325 1.541 5.017.836 2.721 1.125 3.662Z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#354242",
    fillRule: "evenodd",
    d: "M408.868 176.748c-.425.627-1.046 1.617-1.386 2.417l1.127 3.542c.302-.885.908-1.94 1.331-2.603l-1.072-3.356Z",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M380.818 179.857c-2.473.126-4.43 4.415-4.37 9.581.06 5.166 2.115 9.251 4.588 9.126h4.486l-.519-11.414-4.185-7.293Z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m386.747 177.267-2.315 1.645c-1.064.055-.964.794-1.566 2.01a5.659 5.659 0 0 1-.211.389c-.398.681-.744 1.489-1.028 2.388-.547 1.736-.855 3.823-.83 6.055.006.447.023.884.055 1.317l-4.966.04a27.26 27.26 0 0 1-.043-1.005c-.002-.106-.006-.209-.006-.315-.008-.721.012-1.424.064-2.115.137-1.909.512-3.677 1.059-5.197 1.102-3.068 2.899-5.111 4.825-5.209l4.962-.003Z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m386.747 176.981-2.315 1.645c-1.064.054-.964.794-1.566 2.01l-5.906 1.557c1.102-3.068 2.899-5.112 4.825-5.209l4.962-.003ZM394.274 179.857c-2.473.126-4.431 4.415-4.37 9.581.06 5.166 2.115 9.251 4.588 9.126h4.439l-4.657-18.707Z",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m399.796 176.98-2.314 1.647c-1.174.06-.934.951-1.777 2.397-.398.682-.744 1.489-1.027 2.387-.548 1.737-.857 3.825-.831 6.056.006.448.024.887.055 1.318l-4.964.039a23.4 23.4 0 0 1-.045-1.004l-.006-.314a24.98 24.98 0 0 1 .064-2.117c.413-5.761 3.001-10.259 5.884-10.404l4.961-.005Z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m399.521 176.981-2.315 1.645c-1.064.054-.965.794-1.565 2.01l-5.908 1.557c1.102-3.068 2.899-5.112 4.826-5.209l4.962-.003ZM407.623 179.857c-2.473.126-4.431 4.415-4.371 9.581.061 5.166 2.115 9.251 4.588 9.126h4.703s-3.703-16.476-3.703-16.614c0-.138-1.217-2.093-1.217-2.093Z",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m413.639 176.98-2.314 1.647c-1.174.06-.933.951-1.778 2.397-.397.682-.743 1.489-1.027 2.387-.548 1.737-.856 3.825-.83 6.056.006.448.024.887.055 1.318l-4.965.039a25.16 25.16 0 0 1-.044-1.004l-.006-.314a24.98 24.98 0 0 1 .064-2.117c.413-5.761 3-10.259 5.885-10.404l4.96-.005Z",
    clipRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m413.42 176.981-2.315 1.645c-1.064.054-.965.794-1.566 2.01l-5.906 1.557c1.102-3.068 2.899-5.112 4.825-5.209l4.962-.003Z",
    clipRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M402.89 180.708c-.877-1.361-1.967-2.962-3.142-2.902-1.174.059-2.961 1.77-3.804 3.217-1.167 2-1.897 5.058-1.858 8.443.006.448.014 1.72.045 2.149l1.192-.06c-.04-.427-.052-1.699-.057-2.149-.052-4.477 1.65-8.207 3.795-8.317 2.146-.108 3.933 3.445 3.985 7.923.005.449-.007.891-.037 1.322l1.908-.061c.021-.432.029-.874.024-1.321-.04-3.385-.84-6.365-2.051-8.244Z",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M403.874 188.983c-.06-5.165-2.115-9.251-4.589-9.126-2.473.126-4.431 4.416-4.37 9.58.06 5.166 2.115 9.253 4.588 9.127 2.474-.126 4.431-4.415 4.371-9.581Z",
    clipRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M405.376 186.805c-.547-5.713-3.001-9.967-5.886-9.82-2.883.146-5.236 4.643-5.65 10.405a25.371 25.371 0 0 0-.013 3.434l.791-.04c-.03-.43-.049-.87-.054-1.318-.04-3.386.69-6.443 1.857-8.443.843-1.446 1.914-2.337 3.089-2.396 1.174-.06 2.264.72 3.141 2.081 1.211 1.879 2.012 4.858 2.051 8.244.006.448-.003.889-.023 1.322l-.597.03 1.387-.071a25.158 25.158 0 0 0-.093-3.428Z",
    clipRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M417.487 188.983c-.06-5.165-2.115-9.251-4.588-9.126-2.474.126-4.431 4.416-4.372 9.58.061 5.166 2.115 9.253 4.589 9.127 2.475-.126 4.431-4.415 4.371-9.581Z",
    clipRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M418.989 186.805c-.547-5.713-3.001-9.967-5.885-9.82-2.885.146-5.237 4.643-5.65 10.405a25.768 25.768 0 0 0-.014 3.434l.792-.04c-.031-.43-.051-.87-.055-1.318-.039-3.386.691-6.443 1.857-8.443.843-1.446 1.915-2.337 3.089-2.396 1.174-.06 2.264.72 3.14 2.081 1.213 1.879 2.013 4.858 2.053 8.244.005.448-.004.889-.025 1.322l-.595.03 1.386-.071a25.158 25.158 0 0 0-.093-3.428ZM389.481 180.708c-.877-1.361-1.966-2.962-3.141-2.902-1.174.059-2.961 1.77-3.805 3.217-1.166 2-1.896 5.058-1.857 8.443.005.448.014 1.72.045 2.149l1.191-.06c-.039-.427-.051-1.699-.056-2.149-.052-4.477 1.65-8.207 3.794-8.317 2.146-.108 3.933 3.445 3.985 7.923.006.449-.007.891-.036 1.322l1.907-.061c.021-.432.03-.874.025-1.321-.04-3.385-.841-6.365-2.052-8.244Z",
    clipRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M390.465 188.983c-.059-5.165-2.114-9.251-4.588-9.126-2.473.126-4.431 4.416-4.37 9.58.059 5.166 2.115 9.253 4.588 9.127 2.474-.126 4.431-4.415 4.37-9.581Z",
    clipRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M391.968 186.805c-.548-5.713-3.001-9.967-5.886-9.82-2.884.146-5.236 4.643-5.65 10.405a25.81 25.81 0 0 0-.013 3.434l.791-.04c-.03-.43-.05-.87-.054-1.318-.04-3.386.69-6.443 1.857-8.443.843-1.446 1.914-2.337 3.089-2.396 1.174-.06 2.264.72 3.14 2.081 1.212 1.879 2.012 4.858 2.052 8.244.005.448-.004.889-.024 1.322l-.596.03 1.387-.071a25.129 25.129 0 0 0-.093-3.428Z",
    clipRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C4C",
    fillRule: "evenodd",
    d: "M359.88 174.086v3.508c0 .529.434.962.962.962h79.67a.965.965 0 0 0 .962-.962v-3.648",
    clipRule: "evenodd"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C4C",
    fillRule: "evenodd",
    d: "m412.843 184.032-1.317 1.604-1.023-3.33-.88-2.859-1.598-5.205 1.317-1.61 1.46 4.755.833 2.714 1.208 3.931ZM426.153 184.032l-1.32 1.604-.876-2.851-.895-2.911-1.3-4.235-1.382 4.497-1.108 3.603-.584 1.897-1.318-1.604.906-2.95.977-3.183 1.617-5.267.892 1.086.888-1.086 1.558 5.07.837 2.723 1.108 3.607ZM452.348 174.242l-1.697 5.528-1.08 3.514-.723 2.352-1.32-1.604 1.001-3.262.966-3.144 1.535-4.994 1.318 1.61ZM440.427 184.032l-1.32 1.604-.898-2.929-.894-2.907-1.476-4.804-1.444 4.704-1.077 3.5-.748 2.436-1.32-1.604 1.02-3.319.966-3.142 1.517-4.939 1.086 1.325 1.085-1.325 1.541 5.017.837 2.721 1.125 3.662Z",
    clipRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#354242",
    fillRule: "evenodd",
    d: "M441.042 176.748c-.425.627-1.046 1.617-1.386 2.417l1.128 3.542c.302-.885.908-1.94 1.33-2.603l-1.072-3.356Z",
    clipRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M412.993 179.857c-2.473.126-4.431 4.415-4.37 9.581.06 5.166 2.115 9.251 4.588 9.126h4.486l-.519-11.414-4.185-7.293Z",
    clipRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m418.922 176.981-2.315 1.645c-1.064.054-.965.794-1.566 2.01a6.126 6.126 0 0 1-.211.389c-.398.682-.744 1.488-1.028 2.387-.547 1.737-.856 3.824-.83 6.057.006.446.022.883.054 1.316l-4.965.04a27.45 27.45 0 0 1-.043-1.005c-.003-.106-.006-.209-.006-.315-.008-.721.012-1.425.064-2.115.136-1.909.512-3.678 1.058-5.197 1.102-3.068 2.899-5.112 4.826-5.209l4.962-.003Z",
    clipRule: "evenodd"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m418.922 176.981-2.315 1.645c-1.064.054-.965.794-1.566 2.01l-5.907 1.557c1.102-3.068 2.899-5.112 4.826-5.209l4.962-.003Z",
    clipRule: "evenodd"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M426.449 179.857c-2.473.126-4.431 4.415-4.37 9.581.059 5.166 2.115 9.251 4.588 9.126h4.439l-4.657-18.707Z",
    clipRule: "evenodd"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m431.971 176.98-2.314 1.647c-1.174.06-.933.951-1.778 2.397a11.854 11.854 0 0 0-1.027 2.387c-.547 1.737-.856 3.825-.829 6.056.005.448.023.887.054 1.318l-4.965.039a27.173 27.173 0 0 1-.045-1.004l-.005-.314a24.57 24.57 0 0 1 .064-2.117c.413-5.761 3-10.259 5.885-10.404l4.96-.005Z",
    clipRule: "evenodd"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m431.696 176.981-2.315 1.645c-1.065.054-.965.794-1.566 2.01l-5.907 1.557c1.102-3.068 2.899-5.112 4.826-5.209l4.962-.003Z",
    clipRule: "evenodd"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M439.798 179.857c-2.473.126-4.431 4.415-4.371 9.581.06 5.166 2.115 9.251 4.588 9.126h4.704s-3.704-16.476-3.704-16.614c0-.138-1.217-2.093-1.217-2.093Z",
    clipRule: "evenodd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m445.814 176.98-2.314 1.647c-1.174.06-.933.951-1.778 2.397a11.854 11.854 0 0 0-1.027 2.387c-.548 1.737-.856 3.825-.83 6.056.006.448.024.887.055 1.318l-4.965.039a27.173 27.173 0 0 1-.045-1.004l-.005-.314c-.009-.721.013-1.426.063-2.117.414-5.761 3.001-10.259 5.885-10.404l4.961-.005Z",
    clipRule: "evenodd"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "m445.595 176.981-2.315 1.645c-1.064.054-.965.794-1.566 2.01l-5.907 1.557c1.103-3.068 2.9-5.112 4.826-5.209l4.962-.003Z",
    clipRule: "evenodd"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M435.064 180.708c-.876-1.361-1.966-2.962-3.141-2.902-1.174.059-2.961 1.77-3.805 3.217-1.166 2-1.896 5.058-1.857 8.443.005.448.014 1.72.045 2.149l1.192-.06c-.04-.427-.052-1.699-.057-2.149-.052-4.477 1.65-8.207 3.794-8.317 2.146-.108 3.934 3.445 3.985 7.923.006.449-.007.891-.036 1.322l1.908-.061c.021-.432.028-.874.024-1.321-.04-3.385-.84-6.365-2.052-8.244Z",
    clipRule: "evenodd"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M436.049 188.983c-.06-5.165-2.115-9.251-4.589-9.126-2.473.126-4.43 4.416-4.37 9.58.059 5.166 2.115 9.253 4.588 9.127 2.474-.126 4.431-4.415 4.371-9.581Z",
    clipRule: "evenodd"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M431.651 196.28c-1.866.095-3.422-3-3.468-6.899-.045-3.897 1.437-7.145 3.304-7.239 1.867-.096 3.423 2.999 3.468 6.896.045 3.898-1.437 7.148-3.304 7.242Z",
    clipRule: "evenodd"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#67666C",
    fillRule: "evenodd",
    d: "M434.097 189.089c.006.514-.024 1.011-.087 1.481-.213 1.589-.786 2.871-1.531 3.42a1.37 1.37 0 0 1-.75.287 1.282 1.282 0 0 1-.755-.211c-.746-.463-1.345-1.659-1.598-3.196a10.424 10.424 0 0 1-.037-3.082c.22-1.574.797-2.835 1.54-3.369.229-.166.476-.262.732-.276.256-.013.505.058.739.202.764.463 1.375 1.691 1.625 3.271.073.463.116.958.122 1.473Z",
    clipRule: "evenodd"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#303035",
    fillRule: "evenodd",
    d: "M431.572 189.099a9.85 9.85 0 0 1-.067 1.295c-.163 1.388-.61 2.507-1.192 2.983-.183.15-.381.238-.586.249a.936.936 0 0 1-.591-.188c-.584-.409-1.053-1.455-1.254-2.801a9.797 9.797 0 0 1-.106-1.341c-.005-.471.021-.924.073-1.352.171-1.376.62-2.476 1.199-2.938a.99.99 0 0 1 .573-.239.915.915 0 0 1 .578.179c.599.407 1.077 1.484 1.275 2.864.058.406.093.839.098 1.289Z",
    clipRule: "evenodd"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#303035",
    fillRule: "evenodd",
    d: "M430.068 189.181c.001.131-.006.257-.023.376-.054.405-.2.731-.389.869a.321.321 0 0 1-.383.019c-.191-.118-.344-.423-.408-.815a2.66 2.66 0 0 1-.009-.784c.056-.4.203-.72.391-.855a.349.349 0 0 1 .188-.07.33.33 0 0 1 .188.051c.194.119.35.432.414.834.018.118.029.244.031.375Z",
    clipRule: "evenodd"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M437.551 186.805c-.547-5.713-3.002-9.967-5.886-9.82-2.883.146-5.236 4.643-5.65 10.405a25.371 25.371 0 0 0-.013 3.434l.791-.04c-.03-.43-.05-.87-.054-1.318-.04-3.386.69-6.443 1.856-8.443.844-1.446 1.915-2.337 3.09-2.396 1.174-.06 2.264.72 3.141 2.081 1.211 1.879 2.011 4.858 2.051 8.244.005.448-.003.889-.023 1.322l-.597.03 1.387-.071a25.129 25.129 0 0 0-.093-3.428Z",
    clipRule: "evenodd"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D5DD",
    fillRule: "evenodd",
    d: "M434.1 192.277v.004c-.496 1.774-1.407 2.985-2.46 3.039-1.538.08-2.834-2.352-2.982-5.501h.285c.514-1.042 1.663-2.311 5.157 2.458Z",
    clipRule: "evenodd"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBDBF",
    fillRule: "evenodd",
    d: "M432.423 193.987a1.382 1.382 0 0 1-.751.288 1.283 1.283 0 0 1-.755-.211c-.745-.464-1.345-1.659-1.598-3.197a10.305 10.305 0 0 1-.036-3.082c.22-1.574.797-2.835 1.539-3.369.229-.166.476-.263.733-.275.256-.013.504.058.738.201.764.463 1.374 1.691 1.625 3.27.073.464.116.96.122 1.474.007.514-.024 1.011-.087 1.481-.212 1.589-.786 2.872-1.53 3.42Zm-.925-10.887c-1.613.082-2.894 2.889-2.856 6.258.04 3.37 1.385 6.044 2.998 5.963 1.614-.082 2.895-2.89 2.856-6.26-.04-3.368-1.384-6.043-2.998-5.961Z",
    clipRule: "evenodd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M448.677 180.708c-.876-1.361-1.967-2.962-3.141-2.902-1.174.059-2.96 1.77-3.804 3.217-1.167 2-1.897 5.058-1.858 8.443.005.448.014 1.72.044 2.149l1.193-.06c-.04-.427-.052-1.699-.058-2.149-.051-4.477 1.651-8.207 3.796-8.317 2.145-.108 3.933 3.445 3.985 7.923.005.449-.008.891-.038 1.322l1.908-.061c.021-.432.03-.874.025-1.321-.039-3.385-.841-6.365-2.052-8.244Z",
    clipRule: "evenodd"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M449.662 188.983c-.06-5.165-2.115-9.251-4.589-9.126-2.473.126-4.431 4.416-4.371 9.58.061 5.166 2.115 9.253 4.588 9.127 2.475-.126 4.431-4.415 4.372-9.581Z",
    clipRule: "evenodd"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M445.264 196.28c-1.867.095-3.422-3-3.468-6.899-.045-3.897 1.437-7.145 3.304-7.239 1.867-.096 3.422 2.999 3.468 6.896.045 3.898-1.437 7.148-3.304 7.242Z",
    clipRule: "evenodd"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#67666C",
    fillRule: "evenodd",
    d: "M447.71 189.089c.006.514-.024 1.011-.088 1.481-.212 1.589-.786 2.871-1.53 3.42a1.37 1.37 0 0 1-.75.287 1.282 1.282 0 0 1-.755-.211c-.746-.463-1.345-1.659-1.599-3.196a10.355 10.355 0 0 1-.036-3.082c.22-1.574.797-2.835 1.539-3.369.23-.166.476-.262.733-.276.257-.013.505.058.738.202.764.463 1.375 1.691 1.626 3.271.074.463.116.958.122 1.473Z",
    clipRule: "evenodd"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#303035",
    fillRule: "evenodd",
    d: "M445.185 189.099a9.68 9.68 0 0 1-.067 1.295c-.163 1.388-.61 2.507-1.191 2.983-.184.15-.381.238-.587.249a.934.934 0 0 1-.591-.188c-.584-.409-1.054-1.455-1.255-2.801a10.147 10.147 0 0 1-.031-2.693c.169-1.376.619-2.476 1.199-2.938a.985.985 0 0 1 .572-.239.913.913 0 0 1 .578.179c.599.407 1.078 1.484 1.276 2.864.058.406.092.839.097 1.289Z",
    clipRule: "evenodd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#303035",
    fillRule: "evenodd",
    d: "M443.68 189.181c.003.131-.006.257-.021.376-.055.405-.2.731-.39.869a.352.352 0 0 1-.191.073.326.326 0 0 1-.193-.054c-.19-.118-.342-.423-.408-.815a2.623 2.623 0 0 1-.008-.784c.056-.4.202-.72.392-.855a.34.34 0 0 1 .187-.07.332.332 0 0 1 .188.051c.195.119.35.432.413.834.019.118.03.244.031.375Z",
    clipRule: "evenodd"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M451.164 186.805c-.547-5.713-3.001-9.967-5.886-9.82-2.884.146-5.236 4.643-5.65 10.405a25.778 25.778 0 0 0-.014 3.434l.792-.04c-.031-.43-.05-.87-.054-1.318-.04-3.386.69-6.443 1.857-8.443.843-1.446 1.915-2.337 3.089-2.396 1.173-.06 2.264.72 3.14 2.081 1.212 1.879 2.013 4.858 2.052 8.244.006.448-.004.889-.024 1.322l-.596.03 1.386-.071c.019-.434.024-.876.021-1.321a25.59 25.59 0 0 0-.113-2.107Z",
    clipRule: "evenodd"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D5DD",
    fillRule: "evenodd",
    d: "M447.713 192.277v.004c-.496 1.774-1.407 2.985-2.46 3.039-1.538.08-2.834-2.352-2.982-5.501h.285c.514-1.042 1.31-1.899 5.157 2.458Z",
    clipRule: "evenodd"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBDBF",
    fillRule: "evenodd",
    d: "M446.036 193.987a1.384 1.384 0 0 1-.751.288 1.279 1.279 0 0 1-.754-.211c-.747-.464-1.345-1.659-1.6-3.197a10.37 10.37 0 0 1-.035-3.082c.219-1.574.796-2.835 1.538-3.369a1.36 1.36 0 0 1 .733-.275c.257-.013.505.058.739.201.764.463 1.374 1.691 1.625 3.27.073.464.117.96.122 1.474.006.514-.024 1.011-.088 1.481-.211 1.589-.785 2.872-1.529 3.42Zm-.925-10.887c-1.614.082-2.895 2.889-2.855 6.258.039 3.37 1.383 6.044 2.997 5.963 1.614-.082 2.895-2.89 2.856-6.26-.04-3.368-1.384-6.043-2.998-5.961Z",
    clipRule: "evenodd"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#21211F",
    fillRule: "evenodd",
    d: "M421.656 180.708c-.876-1.361-1.967-2.962-3.142-2.902-1.173.059-2.96 1.77-3.804 3.217-1.166 2-1.896 5.058-1.857 8.443.005.448.014 1.72.045 2.149l1.191-.06c-.04-.427-.051-1.699-.057-2.149-.052-4.477 1.651-8.207 3.795-8.317 2.146-.108 3.933 3.445 3.985 7.923.006.449-.008.891-.036 1.322l1.907-.061c.021-.432.029-.874.025-1.321-.04-3.385-.841-6.365-2.052-8.244Z",
    clipRule: "evenodd"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M422.64 188.983c-.06-5.165-2.114-9.251-4.588-9.126-2.473.126-4.431 4.416-4.37 9.58.059 5.166 2.115 9.253 4.588 9.127 2.474-.126 4.431-4.415 4.37-9.581Z",
    clipRule: "evenodd"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#434856",
    fillRule: "evenodd",
    d: "M418.243 196.28c-1.866.095-3.423-3-3.468-6.899-.045-3.897 1.437-7.145 3.303-7.239 1.867-.096 3.424 2.999 3.469 6.896.045 3.898-1.437 7.148-3.304 7.242Z",
    clipRule: "evenodd"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#67666C",
    fillRule: "evenodd",
    d: "M420.688 189.089c.007.514-.024 1.011-.087 1.481-.212 1.589-.786 2.871-1.53 3.42a1.372 1.372 0 0 1-.75.287 1.282 1.282 0 0 1-.755-.211c-.746-.463-1.345-1.659-1.599-3.196a10.225 10.225 0 0 1-.132-1.535c-.007-.539.027-1.057.096-1.547.22-1.574.797-2.835 1.539-3.369.229-.166.476-.262.733-.276.256-.013.505.058.738.202.765.463 1.375 1.691 1.626 3.271.073.463.115.958.121 1.473Z",
    clipRule: "evenodd"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#303035",
    fillRule: "evenodd",
    d: "M418.164 189.099a9.85 9.85 0 0 1-.067 1.295c-.163 1.388-.61 2.507-1.192 2.983-.184.15-.381.238-.586.249a.939.939 0 0 1-.592-.188c-.584-.409-1.053-1.455-1.253-2.801a9.954 9.954 0 0 1-.033-2.693c.171-1.376.619-2.476 1.199-2.938a.988.988 0 0 1 .573-.239.915.915 0 0 1 .578.179c.599.407 1.077 1.484 1.275 2.864.058.406.092.839.098 1.289Z",
    clipRule: "evenodd"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#303035",
    fillRule: "evenodd",
    d: "M416.66 189.181c.001.131-.006.257-.023.376-.054.405-.2.731-.389.869a.35.35 0 0 1-.192.073.325.325 0 0 1-.192-.054c-.19-.118-.343-.423-.407-.815a2.53 2.53 0 0 1-.009-.784c.056-.4.202-.72.391-.855a.343.343 0 0 1 .188-.07.332.332 0 0 1 .188.051c.194.119.349.432.414.834.018.118.029.244.031.375Z",
    clipRule: "evenodd"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M424.143 186.805c-.548-5.713-3.002-9.967-5.886-9.82-2.884.146-5.237 4.643-5.65 10.405a25.371 25.371 0 0 0-.013 3.434l.791-.04c-.03-.43-.05-.87-.054-1.318-.04-3.386.69-6.443 1.856-8.443.844-1.446 1.915-2.337 3.089-2.396 1.175-.06 2.265.72 3.141 2.081 1.212 1.879 2.012 4.858 2.052 8.244.005.448-.004.889-.024 1.322l-.596.03 1.387-.071a25.129 25.129 0 0 0-.093-3.428Z",
    clipRule: "evenodd"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D5DD",
    fillRule: "evenodd",
    d: "M420.691 192.277v.004c-.495 1.774-1.406 2.985-2.459 3.039-1.538.08-2.834-2.352-2.982-5.501h.285c.514-1.042 1.476-2.207 5.156 2.458Z",
    clipRule: "evenodd"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBDBF",
    fillRule: "evenodd",
    d: "M419.015 193.987a1.382 1.382 0 0 1-.751.288 1.282 1.282 0 0 1-.755-.211c-.746-.464-1.345-1.659-1.598-3.197a10.441 10.441 0 0 1-.037-3.082c.22-1.574.797-2.835 1.54-3.369.229-.166.476-.263.732-.275.257-.013.505.058.739.201.764.463 1.374 1.691 1.625 3.27.073.464.116.96.122 1.474.007.514-.024 1.011-.087 1.481-.213 1.589-.786 2.872-1.53 3.42Zm-.925-10.887c-1.614.082-2.895 2.889-2.856 6.258.04 3.37 1.384 6.044 2.998 5.963 1.613-.082 2.895-2.89 2.856-6.26-.04-3.368-1.384-6.043-2.998-5.961Z",
    clipRule: "evenodd"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3C4C",
    fillRule: "evenodd",
    d: "M393.384 183.826h3.514v-7.936h-3.514v7.936Z",
    clipRule: "evenodd"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8FF",
    fillRule: "evenodd",
    d: "M362.759 174.767a2.893 2.893 0 0 1-2.884-2.885v-40.769a2.892 2.892 0 0 1 2.884-2.884H466.36a2.893 2.893 0 0 1 2.884 2.884v40.769a2.894 2.894 0 0 1-2.884 2.885H362.759Z",
    clipRule: "evenodd"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M361.725 171.766h37.76v-40.84h-37.76v40.84Z",
    clipRule: "evenodd"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#566666",
    fillRule: "evenodd",
    d: "M359.831 176.022h41.576v-2.307h-41.576v2.307Z",
    clipRule: "evenodd"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#63798E",
    fillRule: "evenodd",
    d: "M400.705 176.023h97.651v-2.306h-97.651v2.306Z",
    clipRule: "evenodd"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4E3EC",
    fillRule: "evenodd",
    d: "M359.276 187.119h42.251v-4.476h-42.251v4.476Z",
    clipRule: "evenodd"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M359.276 189.335h42.251v-4.476h-42.251v4.476Z",
    clipRule: "evenodd"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4E3EC",
    fillRule: "evenodd",
    d: "M400.2 182.643v6.691h2.525v-6.691H400.2Z",
    clipRule: "evenodd"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M364.912 186.848c0-.556-.454-1.009-1.009-1.009h-2.307c-.555 0-1.009.453-1.009 1.009v.498c0 .554.454 1.009 1.009 1.009h2.307c.555 0 1.009-.455 1.009-1.009v-.498Z",
    clipRule: "evenodd"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M384.09 186.125a.287.287 0 0 0-.287-.286h-9.095a.287.287 0 0 0-.285.286v1.658c0 .157.129.286.285.286h9.095a.287.287 0 0 0 .287-.286v-1.658Z",
    clipRule: "evenodd"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M398.684 186.848c0-.556-.454-1.009-1.009-1.009h-2.307c-.555 0-1.009.453-1.009 1.009v.498c0 .554.454 1.009 1.009 1.009h2.307c.555 0 1.009-.455 1.009-1.009v-.498Z",
    clipRule: "evenodd"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    stroke: "#006E17",
    d: "M520.752 152.255h-17.746"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AB75",
    fillRule: "evenodd",
    d: "M389.1 156.166h14.258v-15.971H389.1v15.971Z",
    clipRule: "evenodd"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A86951",
    strokeWidth: 1.043,
    d: "M398.311 140.195v16.08M389.1 148.074h14.054"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M401.969 141.684h1.497v-1.382h-1.497v1.382ZM392.768 141.578h1.497v-1.383h-1.497v1.383ZM401.969 149.767h1.497v-1.382h-1.497v1.382ZM392.491 149.767h1.497v-1.382h-1.497v1.382Z",
    clipRule: "evenodd"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D7A",
    fillRule: "evenodd",
    d: "m399.485 171.767-37.76-40.841h37.76v40.841Z",
    clipRule: "evenodd"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8E2",
    fillRule: "evenodd",
    d: "M346.686 171.766h15.101v-40.84h-15.101v40.84Z",
    clipRule: "evenodd"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DEC1",
    fillRule: "evenodd",
    d: "M378.077 171.631h9.111v-17.769h-9.111v17.769Z",
    clipRule: "evenodd"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M386.635 171.681h8.202v-17.819h-8.202v17.819Z",
    clipRule: "evenodd"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M381.982 160.886H383v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2D8EF",
    fillRule: "evenodd",
    d: "M393.458 165.255h.952v-.866h-.952v.866Z",
    clipRule: "evenodd"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M388.619 165.255h1.588v-.866h-1.588v.866ZM387.577 165.255h.818v-.866h-.818v.866ZM388.619 159.263h1.588v-.865h-1.588v.865ZM387.577 159.263h.818v-.865h-.818v.865ZM388.619 171.23h1.588v-.866h-1.588v.866ZM387.577 171.23h.818v-.866h-.818v.866Z",
    clipRule: "evenodd"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2D8EF",
    fillRule: "evenodd",
    d: "M393.458 171.278h.952v-.866h-.952v.866ZM393.458 159.329h.952v-.866h-.952v.866Z",
    clipRule: "evenodd"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M381.891 155.065h1.018v-1.203h-1.018v1.203ZM381.891 166.807h1.018v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#A86951",
    fillRule: "evenodd",
    d: "M397.038 160.8h1.018v-1.111h-1.018v1.111ZM396.947 154.814h1.018v-.952h-1.018v.952ZM396.947 166.994h1.018v-1.389h-1.018v1.389Z",
    clipRule: "evenodd"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DEC1",
    fillRule: "evenodd",
    d: "M386.903 171.631h9.634v-17.769h-9.634v17.769Z",
    clipRule: "evenodd"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M390.832 160.886h1.018v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M397.967 165.255h.818v-.866h-.818v.866ZM396.925 165.255h.818v-.866h-.818v.866ZM395.916 165.255h.818v-.866h-.818v.866ZM397.967 159.263h.818v-.865h-.818v.865ZM396.925 159.263h.818v-.865h-.818v.865ZM395.916 159.263h.818v-.865h-.818v.865ZM397.967 171.23h.818v-.866h-.818v.866ZM396.925 171.23h.818v-.866h-.818v.866ZM395.916 171.23h.818v-.866h-.818v.866Z",
    clipRule: "evenodd"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M390.832 155.065h1.018v-1.203h-1.018v1.203ZM390.832 166.807h1.018v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD18D",
    fillRule: "evenodd",
    d: "M378.077 171.748h9.111v-.203h-9.111v.203Z",
    clipRule: "evenodd"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M386.617 171.748h9.11v-.203h-9.11v.203Z",
    clipRule: "evenodd"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD18D",
    fillRule: "evenodd",
    d: "M386.903 171.748h9.634v-.203h-9.634v.203Z",
    clipRule: "evenodd"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M397.967 171.346h.818v-.866h-.818v.866ZM396.925 171.346h.818v-.866h-.818v.866ZM395.916 171.346h.818v-.866h-.818v.866Z",
    clipRule: "evenodd"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M395.48 171.631h8.203v-17.769h-8.203v17.769Z",
    clipRule: "evenodd"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M390.828 160.886h1.017v-1.203h-1.017v1.203Z",
    clipRule: "evenodd"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2D8EF",
    fillRule: "evenodd",
    d: "M402.304 165.255h.952v-.866h-.952v.866Z",
    clipRule: "evenodd"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M397.464 165.255h1.588v-.866h-1.588v.866ZM396.422 165.255h.818v-.866h-.818v.866ZM397.464 159.263h1.588v-.865h-1.588v.865ZM396.422 159.263h.818v-.865h-.818v.865ZM397.464 171.23h1.588v-.866h-1.588v.866ZM396.422 171.23h.818v-.866h-.818v.866Z",
    clipRule: "evenodd"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2D8EF",
    fillRule: "evenodd",
    d: "M402.304 171.278h.952v-.866h-.952v.866ZM402.304 159.329h.952v-.866h-.952v.866Z",
    clipRule: "evenodd"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M390.736 155.065h1.018v-1.203h-1.018v1.203ZM390.736 166.807h1.018v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#BA6145",
    fillRule: "evenodd",
    d: "M402.713 171.631h9.634v-17.769h-9.634v17.769Z",
    clipRule: "evenodd"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M411.271 171.631h6.414v-17.769h-6.414v17.769Z",
    clipRule: "evenodd"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#A86951",
    fillRule: "evenodd",
    d: "M405.884 160.8h1.017v-1.111h-1.017v1.111Z",
    clipRule: "evenodd"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M413.778 165.255h.817v-.866h-.817v.866ZM412.737 165.255h.817v-.866h-.817v.866ZM411.727 165.255h.818v-.866h-.818v.866ZM413.778 159.263h.817v-.865h-.817v.865ZM412.737 159.263h.817v-.865h-.817v.865ZM411.727 159.263h.818v-.865h-.818v.865ZM413.778 171.23h.817v-.866h-.817v.866ZM412.737 171.23h.817v-.866h-.817v.866ZM411.727 171.23h.818v-.866h-.818v.866Z",
    clipRule: "evenodd"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#A86951",
    fillRule: "evenodd",
    d: "M405.792 154.814h1.018v-.952h-1.018v.952ZM405.792 166.994h1.018v-1.389h-1.018v1.389Z",
    clipRule: "evenodd"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DEC1",
    fillRule: "evenodd",
    d: "M395.747 171.631h9.634v-17.769h-9.634v17.769Z",
    clipRule: "evenodd"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M404.306 171.631h6.414v-17.769h-6.414v17.769Z",
    clipRule: "evenodd"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M399.678 160.886h1.018v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    fillRule: "evenodd",
    d: "M406.812 165.255h.818v-.866h-.818v.866ZM405.771 165.255h.817v-.866h-.817v.866ZM404.761 165.255h.818v-.866h-.818v.866ZM406.812 159.263h.818v-.865h-.818v.865ZM405.771 159.263h.817v-.865h-.817v.865ZM404.761 159.263h.818v-.865h-.818v.865ZM406.812 171.23h.818v-.866h-.818v.866ZM405.771 171.23h.817v-.866h-.817v.866ZM404.761 171.23h.818v-.866h-.818v.866Z",
    clipRule: "evenodd"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#A58258",
    fillRule: "evenodd",
    d: "M399.678 155.065h1.018v-1.203h-1.018v1.203ZM399.678 166.807h1.018v-1.203h-1.018v1.203Z",
    clipRule: "evenodd"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD18D",
    fillRule: "evenodd",
    d: "M386.923 171.748h9.11v-.203h-9.11v.203Z",
    clipRule: "evenodd"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M395.48 171.748h8.203v-.203h-8.203v.203Z",
    clipRule: "evenodd"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2D8EF",
    fillRule: "evenodd",
    d: "M402.304 171.395h.952v-.866h-.952v.866Z",
    clipRule: "evenodd"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#BA6145",
    fillRule: "evenodd",
    d: "M402.713 171.748h9.634v-.203h-9.634v.203Z",
    clipRule: "evenodd"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M411.271 171.748h6.414v-.203h-6.414v.203Z",
    clipRule: "evenodd"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD18D",
    fillRule: "evenodd",
    d: "M395.747 171.748h9.634v-.203h-9.634v.203Z",
    clipRule: "evenodd"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#D88850",
    fillRule: "evenodd",
    d: "M404.306 171.748h6.414v-.203h-6.414v.203Z",
    clipRule: "evenodd"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C9804F",
    strokeWidth: 0.535,
    d: "M417.69 171.66h-39.62M393.868 159.793h6.379-22.169M386.9 165.713h-8.824 22.477-6.687"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4E3EC",
    fillRule: "evenodd",
    d: "M404.133 174.922a2.893 2.893 0 0 1-2.884-2.885v-40.768a2.893 2.893 0 0 1 2.884-2.884h90.149a2.893 2.893 0 0 1 2.884 2.884v40.768a2.893 2.893 0 0 1-2.884 2.885h-90.149Z",
    clipRule: "evenodd"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FBFF",
    fillRule: "evenodd",
    d: "M399.485 171.829h6.935v-40.903h-6.935v40.903Z",
    clipRule: "evenodd"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M150.845 194.699c-.143.45.107.678.126.772.37 1.788 5.244 1.438 5.448 1.264.205-.173.579-4.989.512-5.221-.068-.233-3.27-.471-3.729-.516-.46-.045-1.628-.723-1.413-.561.089.067-.801 3.812-.944 4.262Z",
    clipRule: "evenodd"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M150.767 195.439s-.188.998 1.603.947c1.711-.049 2.646-2.048 2.646-2.048l2.766-.164s.193 1.257.412 1.559c.598.821 2.144 2.414 2.144 2.414l3.184.057s.25 2.552-.728 2.581c-.976.027-2.909.066-3.723.09-.815.022-5.111-.965-5.111-.965s-3.662.15-3.662.102c-.007-3.456.469-4.573.469-4.573Z",
    clipRule: "evenodd"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "m150.235 200.691 5.553.007.026-.841-2.465-.543-3.18.029.066 1.348Z",
    clipRule: "evenodd"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M163.88 198.711v.007c-.003.042-.014.248-.052.424a4.96 4.96 0 0 1-.052.196c0 .007-.009.021-.009.028a2.73 2.73 0 0 1-.025.063c0 .014-.007.028-.008.035-.016.02-.023.041-.032.062-.001.014-.009.021-.009.028-.016.035-.031.07-.055.104l-.023.041-.024.042c-.015.021-.022.034-.037.048-.009.013-.016.02-.023.034a.732.732 0 0 1-.061.068l-.022.019a.358.358 0 0 1-.045.048c-.008.007-.023.013-.03.02-.015.013-.037.026-.059.039-.007 0-.008.007-.015.007a.167.167 0 0 1-.079.038c-.008.007-.015.007-.022.014l-.065.017c-.007 0-.015.007-.029.006-.029.005-.057.011-.086.009l-1.672.048c-.612.019-1.238.035-1.686.048a15.97 15.97 0 0 0-.285.007c-.029.005-.056.003-.084.003l-.1-.006a.153.153 0 0 1-.063-.011l-.135-.007c-.014-.007-.035-.008-.049-.009-.036-.001-.064-.011-.099-.012l-.05-.003c-.035-.009-.07-.011-.112-.02l-.036-.001a.67.67 0 0 0-.134-.022c-.007-.001-.013-.001-.028-.009-.049-.002-.099-.012-.155-.022-.81-.127-1.894-.34-2.771-.52-.88-.181-1.561-.33-1.561-.33s-3.808.136-3.813.093c-.003-.483.012-.923.033-1.319l.009-.157c.141-2.308.579-3.088.579-3.088s.173 1.316 2.126 1.062c1.366-.177 1.854-1.501 1.987-2.028.043-.132.055-.217.055-.217l.662-.023 1.593-.044.591-.02s.026.179.071.416l-.001.007c.006.036.019.065.024.101-.001.007-.001.014.005.028.005.036.01.072.023.108 0 .008-.001.014.006.022.005.036.01.071.023.108l-.001.014c.012.043.025.079.029.122.007.007.006.014.006.022.012.043.025.079.029.115.008 0 .008.007.008.007.015.371.371.787.371.787.68.852 1.964 2.12 1.964 2.12s.931.141 1.791.114c.861-.019 1.691.294 1.709 1.034a.27.27 0 0 0 .003.085Z",
    clipRule: "evenodd"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M158.055 194.728s-1.844.389-3.428.874c-1.583.486-2.298 2.76-2.298 2.76l-2.103-.503c.142-2.308.58-3.088.58-3.088s.157.996 2.11.742c1.365-.178 1.718-1.467 1.852-1.993l3.078-.076.209 1.284Z",
    clipRule: "evenodd"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M156.134 143.328s.286 3.422.409 7.47c.406 13.655.748 43.548.545 43.548H150.2s-1.735-38.985-2.416-51.018h8.35Z",
    clipRule: "evenodd"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M140.423 194.699c-.143.45.107.678.126.772.37 1.788 5.244 1.438 5.448 1.264.206-.173.579-4.989.511-5.221-.067-.233-3.269-.471-3.729-.516-.459-.045-1.627-.723-1.412-.561.089.067-.801 3.812-.944 4.262Z",
    clipRule: "evenodd"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M140.345 195.439s-.188.998 1.603.947c1.711-.049 2.646-2.048 2.646-2.048l2.766-.164s.193 1.257.412 1.559c.598.821 2.144 2.414 2.144 2.414l3.184.057s.25 2.552-.728 2.581c-.976.027-2.909.066-3.723.09-.815.022-5.111-.965-5.111-.965s-3.662.15-3.662.102c-.007-3.456.469-4.573.469-4.573Z",
    clipRule: "evenodd"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "m139.813 200.691 5.553.007.026-.841-2.464-.543-3.181.029.066 1.348Z",
    clipRule: "evenodd"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M153.458 198.711v.007c-.003.042-.014.248-.052.424-.017.07-.035.133-.052.196 0 .007-.009.021-.009.028a2.73 2.73 0 0 1-.025.063c0 .014-.007.028-.008.035-.016.02-.024.041-.032.062-.001.014-.009.021-.009.028-.016.035-.031.07-.055.104l-.023.041-.024.042c-.015.021-.022.034-.037.048-.009.013-.016.02-.023.034a.732.732 0 0 1-.061.068l-.022.019a.358.358 0 0 1-.045.048c-.008.007-.023.013-.03.02-.015.013-.037.026-.059.039-.007 0-.008.007-.015.007a.167.167 0 0 1-.079.038c-.008.007-.015.007-.022.014l-.065.017c-.007 0-.015.007-.029.006-.029.005-.057.011-.086.009l-1.672.048c-.612.019-1.238.035-1.686.048-.107.002-.207.004-.285.007-.029.005-.057.003-.084.003l-.101-.006a.154.154 0 0 1-.062-.011l-.135-.007c-.014-.007-.035-.008-.049-.009-.036-.001-.064-.011-.099-.012l-.05-.003c-.035-.009-.07-.011-.113-.02l-.035-.001a.67.67 0 0 0-.134-.022c-.007-.001-.014-.001-.028-.009-.049-.002-.099-.012-.155-.022-.81-.127-1.894-.34-2.772-.52-.879-.181-1.56-.33-1.56-.33s-3.808.136-3.813.093c-.004-.483.012-.923.033-1.319l.008-.157c.142-2.308.58-3.088.58-3.088s.173 1.316 2.126 1.062c1.366-.177 1.854-1.501 1.987-2.028.043-.132.055-.217.055-.217l.662-.023 1.593-.044.591-.02s.026.179.071.416l-.001.007c.006.036.018.065.024.101-.001.007-.001.014.005.028.005.036.01.072.023.108 0 .008-.001.014.006.022.005.036.01.071.023.108l-.001.014c.012.043.025.079.029.122.007.007.006.014.006.022.012.043.024.079.03.115.007 0 .007.007.007.007.015.371.371.787.371.787.68.852 1.964 2.12 1.964 2.12s.931.141 1.791.114c.861-.019 1.691.294 1.708 1.034-.001.028-.003.057.004.085Z",
    clipRule: "evenodd"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M147.632 194.728s-2.584.594-4.091 1.13c-1.507.536-3.737 2.001-3.737 2.001.142-2.308.58-3.088.58-3.088s.157.996 2.11.742c1.366-.178 1.717-1.467 1.852-1.993l3.078-.076.208 1.284Z",
    clipRule: "evenodd"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "m139.689 143.328.204 51.018h7.949c.264 0 1.563-51.018 1.563-51.018h-9.716Z",
    clipRule: "evenodd"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M156.889 143.328H139.69l.44 14.4c.082 1.903 1.52.655 3.404.374l9.951-3.057c1.884-.282 3.635-.552 3.632-2.457l-.228-9.26Z",
    clipRule: "evenodd"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M158.147 194.346h-3.439l-1.398-.072-2.728-38.316 6.494-5.115c.407 13.655 1.274 43.503 1.071 43.503Z",
    clipRule: "evenodd"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "m150.161 158.651 1.89-3.401-2.928 1.181 1.038 2.22Z",
    clipRule: "evenodd"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M144.737 91.317c.169-.776.764-1.917 2.656-2.074 1.892-.158 1.953 1.37 1.784 1.65-.171.278-.692.897-.692.897l-1.783.4-1.965-.873Z",
    clipRule: "evenodd"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA68A",
    fillRule: "evenodd",
    d: "m152.682 116.768 3.116 5.55 1.681 2.993 2.207 6.972c.42.751 1.164 1.302 1.991 1.548a3.268 3.268 0 0 0 1.642.07l9.361-5.408a1.841 1.841 0 0 0-.81-3.591l-9.104 5.351-3.073-8.516-.445-.789-3.357-5.982a1.842 1.842 0 0 0-2.506-.703 1.838 1.838 0 0 0-.703 2.505Z",
    clipRule: "evenodd"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "m155.798 122.318 1.681 2.993 2.213-3.574-.444-.789-1.165-.816-2.285 2.186Z",
    clipRule: "evenodd"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7C52C",
    fillRule: "evenodd",
    d: "M156.052 114.914c.66 1.137 3.585 6.708 3.585 6.708l-4.352 2.877-3.238-5.018 4.005-4.567Z",
    clipRule: "evenodd"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE536",
    fillRule: "evenodd",
    d: "M156.576 139.489s.039-.068.082-.159c.014.093-.082.159-.082.159Z",
    clipRule: "evenodd"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "m139.721 118.522.022 17.197s1.157 1.105 3.84 1.967c1.766.57 4.191 1.033 7.379 1.008 4.926-.038 5.665.393 5.696.637.057-.122.127-.284.129-.39.013-.282-.062-1.707.04-2.89.293-3.332.205-2.735.308-7.51.113-5.279.207-9.874.207-9.874 0-1.903-.845-3.616-2.212-4.513-.041-.025-.08-.052-.123-.075a3.963 3.963 0 0 0-1.728-.568 3.272 3.272 0 0 0-.347-.019h-8.058c-.558 0-1.065.337-1.563.337-2.133 0-3.526 2.29-3.588 4.533-.002.052-.002.108-.002.16Z",
    clipRule: "evenodd"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M146.744 127.363h6.125v-6.876h-6.125v6.876Z",
    clipRule: "evenodd"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "m139.721 118.522.022 17.197s1.157 1.105 3.84 1.967l4.224-.198-.125-11.063-4.126-8.313s-1.925.112-3.833.25c-.002.052-.002.108-.002.16Z",
    clipRule: "evenodd"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M139.722 135.878c.01-.319.017-.434.017-.265 0 .236 5.58.538 5.58.538.55-.195.912-.503.912-.955 0-2.93-.064-7.636 0-10.684.029-1.451.014-.812.014-1.493h9.913v13.132l.708-.142v.623h.001l-.001.029v2.738c.003.557.004 1.074 0 1.441v6.447l-17.144 4.245v-15.654Z",
    clipRule: "evenodd"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#602C34",
    fillRule: "evenodd",
    d: "m142.879 144.863-.001-.028.001.028ZM142.977 142.26l-.01-.057.01.057ZM142.928 145.413ZM142.899 145.152l-.004-.042.004.042Z",
    clipRule: "evenodd"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M144.914 113.426c2.859 0 3.486 6.776 3.448 9.784l-.986.053-1.129-.053c.039-3.008-.381-9.82-3.634-9.335 0 0 .492-.24.991-.312.501-.071 1.31-.137 1.31-.137ZM151.363 113.93c.195.07.375.182.544.327 1.769 1.521 2.21 6.765 2.18 9.149l1.225-.097.848.097c.032-2.457-.38-7.641-2.088-9.461a2.355 2.355 0 0 0-.478-.394 1.664 1.664 0 0 0-.881-.253s-.768-.076-1.269-.005c-.018.003-.037.007-.054.008v.424s.002.083-.027.205Z",
    clipRule: "evenodd"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#27A3E0",
    fillRule: "evenodd",
    d: "M148.4 125.815v1.891c0 1.042 1.331 1.894 2.959 1.894 1.628 0 2.96-.852 2.96-1.894v-1.891",
    clipRule: "evenodd"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M151.04 114.087c0 .211-.295.929.38.422a2.02 2.02 0 0 1 .487-.252c.567-.216 1.386-.346 2.165-.312.326.014.645.056.935.133a3.91 3.91 0 0 0-1.413-.526 1.657 1.657 0 0 0-.881-.255s-.768-.075-1.269-.004a1.179 1.179 0 0 1-.054.008v.189h-.444c.049.337.094.597.094.597Z",
    clipRule: "evenodd"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M148.4 126.218h5.919v-1.18H148.4v1.18Z",
    clipRule: "evenodd"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#473F3C",
    fillRule: "evenodd",
    d: "M147.932 122.604a.616.616 0 0 0 .614-.614v-.729a.616.616 0 0 0-.614-.613h-1.296a.615.615 0 0 0-.613.613v.729c0 .338.276.614.613.614h1.296ZM155.792 122.604a.615.615 0 0 0 .614-.614v-.729a.615.615 0 0 0-.614-.613h-1.296a.615.615 0 0 0-.613.613v.729c0 .338.276.614.613.614h1.296Z",
    clipRule: "evenodd"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M147.936 121.879c.228 0 .416-.157.416-.35 0-.193-.188-.351-.416-.351h-.722c-.229 0-.415.158-.415.351 0 .193.186.35.415.35h.722Z",
    clipRule: "evenodd"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#177FBF",
    fillRule: "evenodd",
    d: "M155.772 121.879c.228 0 .415-.157.415-.35 0-.193-.187-.351-.415-.351h-.722c-.229 0-.416.158-.416.351 0 .193.187.35.416.35h.722Z",
    clipRule: "evenodd"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M142.868 97.236c-1.067 1.407-1.682 2.712-1.455 3.541.291 1.068 1.843.777 8.2.438 6.356-.341 9.073-2.314 7.763-5.628-.783-1.984-14.508 1.65-14.508 1.65Z",
    clipRule: "evenodd"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E3925",
    fillRule: "evenodd",
    d: "M142.259 101.149c.284 3.954 1.261 5.022 2.807 5.022 1.267 0 2.317-1.749 2.272-2.159-.046-.408-.5-2.817-.864-2.954-.364-.136-4.215.091-4.215.091Z",
    clipRule: "evenodd"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E3925",
    fillRule: "evenodd",
    d: "M145.876 105.329c-.251-.503-.405 1.098-.409.907-.064-3.366-2.947-.86-3.174-4.587-.194-3.178-.222-3.206-.307-4.749-.17-3.068 1.612-6.323 8.168-6.273 3.65.028 4.587 1.446 5.41 3.305 1.533 3.463.296 7.91.296 7.91l-9.984 3.487Z",
    clipRule: "evenodd"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB287",
    fillRule: "evenodd",
    d: "M151.778 113.725s.049 1.296-2.06 1.296c-2.111 0-3.424-1.296-3.424-1.296V107.3l5.484-.304v6.729Z",
    clipRule: "evenodd"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M151.778 112.351c-1.437.176-5.446-.339-5.446-1.283 0-.945-.038-5.133-.038-5.133l5.484.037v6.379Z",
    clipRule: "evenodd"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M156.516 103.878c0 1.263-1.101 4.174-1.784 5.045-.292.371-.694 1.214-1.619 1.496-.841.254-1.339.434-1.339.889 0 .493-1.036-.463-1.389-.463-4.204 0-6.281-4.528-6.281-7.612l1.295-4.047c0-3.377 2.241-5.804 5.503-5.78 3.262.025 5.888 2.25 5.888 5.627l-.274 4.845Z",
    clipRule: "evenodd"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB287",
    fillRule: "evenodd",
    d: "m156.875 98.9-.042 1.342-.025.763-.092 2.877c-.124 3.541-.92 6.814-5.221 6.779-4.293-.03-5.444-5.227-5.327-8.597l.204-2.93c0-.122 0-.247.008-.363.086-4.396 1.872-6.006 5.028-6.006 3.942 0 5.345 2.31 5.466 5.29.011.277.011.559.001.846Z",
    clipRule: "evenodd"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M153.05 104.694c.612.001 1.133-.344 1.106-.697-.01-.129-.138-.284-.378-.171-.11.052-.408.113-.724.11-.316-.001-.488-.065-.667-.118-.389-.117-.511.036-.522.164-.027.352.573.705 1.185.712ZM146.231 101.756c.089 1.259-.55 2.34-1.429 2.415-.879.075-1.663-.884-1.752-2.142-.089-1.259.401-2.239 1.27-2.394.87-.156 1.822.863 1.911 2.121Z",
    clipRule: "evenodd"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#422B27",
    fillRule: "evenodd",
    d: "M149.95 101.478c0 .3.244.544.546.546a.538.538 0 0 0 .545-.537.548.548 0 0 0-.545-.545.537.537 0 0 0-.546.536ZM154.77 101.562c0 .3.244.543.546.546a.538.538 0 0 0 .545-.537.55.55 0 0 0-.545-.546.538.538 0 0 0-.546.537Z",
    clipRule: "evenodd"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E3925",
    strokeLinecap: "round",
    strokeWidth: 1.39,
    d: "m149.002 99.256 2.456-.049M154.507 99.299l2.115.152"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E3925",
    fillRule: "evenodd",
    d: "M144.909 98.676c0-1.913.856-3.621 2.191-4.739-.643-.8-.877-1.995-.74-2.105.228-.182 3.174-2.371 6.651-.36 2.381 1.376 3.47 2.302 3.063 3.278.004.012.01.022.016.033l-.021-.02c-.368.868-1.187 1.433-1.914 1.433-3.045 0-2.981-1.789-5.249-1.614-.887.068-2.107.293-2.107 2.509 0 2.402-.519 5.246-.534 5.247-.713.046-.723-.416-.723-.416 0-1.273-.19-1.985-1-2.363l.367-.883Z",
    clipRule: "evenodd"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5785C",
    strokeLinecap: "round",
    strokeWidth: 1.517,
    d: "M150.952 107.077c.354-.25.895-.291 1.364-.29.468 0 1.225.041 1.581.292"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#C67560",
    fillRule: "evenodd",
    d: "M156.882 98.492v-.041c-.011-3.167-1.359-5.688-5.474-5.688-3.156 0-4.51 2.193-4.755 6.753.054-.646 1.182-.88 2.668-1.116 6.22-.34 7.512 1.842 7.512 1.842l.024-.776.019-.565c.005-.137.006-.273.006-.41Z",
    clipRule: "evenodd"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#754559",
    fillRule: "evenodd",
    d: "M142.233 100.802c0 .275-.422-.211-.493-.427-.101-.304-.243-.59-.022-.822.118-.124 2.978-3.044 10.709-3.044 3.379 0 4.384.314 4.706 1.358.32 1.036-.319 1.917-.291 1.747.049-.292.097-.946-.169-1.286-.005-.005-.331-.655-4.246-.655-7.236 0-9.839 2.654-9.864 2.681-.115.121-.351.301-.33.448Z",
    clipRule: "evenodd"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M140.988 96.612c0 .085 0 .168.006.255.007.393.029.825.064 1.253.103 1.294.3 2.543.476 2.416.172-.296.442-.604.794-.91.306-.261.673-.523 1.093-.773.733-.436 1.625-.83 2.628-1.133 2.218-.675 4.975-1.068 7.676-1.068.633 0 1.135-.015 1.54-.028.302-.01.553-.02.762-.022.576-.007.856.035 1.133.245.363-.027.428-1.695-.363-3.473-.635-1.44-1.54-2.498-3.569-3.238-.053-.025-.374-.453-.906-.63-.792-.265-1.288-.314-2.328-.302a8.78 8.78 0 0 0-.588.022c-.462.033-.899.08-1.32.143-.009 0-.025.01-.039.01-.213.033-.423.072-.623.115-.362.075-.71.168-1.042.272-2.924.91-4.586 2.826-5.163 5.016a7.334 7.334 0 0 0-.231 1.83Z",
    clipRule: "evenodd"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M156.027 96.603c-.047.151-.111.239-.192.244a1.096 1.096 0 0 0-.57-.222c-.487-.065-1.254.026-2.865.026l-1.565-.044c.389-.031.456-1.806-.386-3.701-.549-1.248-1.976-3.239-3.27-3.368.202-.043.654-.125.867-.158.016 0 .031-.01.041-.01.419-.064.856-.11 1.32-.144a7.787 7.787 0 0 1 1.999.39c.056.02.113.037.167.062 2.03.741 3.263 2.255 3.899 3.696.615 1.383.712 2.7.555 3.229Z",
    clipRule: "evenodd"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M156.021 93.374c-.635-1.44-2.15-3.185-4.035-4.01a1.692 1.692 0 0 0-.165-.06c-.79-.27-1.813-.22-2.851-.207a8.11 8.11 0 0 0-.51.016c-.364.023-.729.086-1.067.13.34.036.675.159.824.22 1.248.521 2.278 2.152 2.803 3.342.841 1.893.753 3.772.366 3.803l1.563.044c2.384 0 2.92-.198 3.435.196.363-.029.428-1.697-.363-3.474Z",
    clipRule: "evenodd"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M141.413 100.746c.496-1.108 2.392-2.349 4.637-3.026 2.217-.674 4.974-1.068 7.675-1.068 2.384 0 2.92-.198 3.435.198.363-.03.427-1.698-.363-3.476-.635-1.44-1.489-2.496-3.52-3.238 1.724 1.065 2.094 3.98 2.134 4.868.016.356-1.964.048-7.811 1.48-4.659 1.14-7.157 2.87-6.187 4.262Z",
    clipRule: "evenodd"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M161.015 95.959s-3.016.683-3.978.937c0 0-.225-.169-.923-.326-.593-.131-1.529-.256-2.959-.256-.831 0-2.09.215-3.251.46-1.524.318-2.878.688-2.878.688l-.115-.776s.854-.587 2.993-1.096c1.442-.344 3.468-.651 6.21-.717.36-.01.733-.014 1.116-.014 2.531 0 3.572.169 3.762.412.085.11.023.688.023.688Z",
    clipRule: "evenodd"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M156.115 94.872v1.698c-.595-.131-1.53-.257-2.96-.257-.831 0-2.09.217-3.251.461v-1.183c1.442-.345 3.468-.653 6.211-.719Z",
    clipRule: "evenodd"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M157.231 95.44c-7.667 0-10.287 2.039-10.287 2.039s3.106-.583 6.211-.583c3.105 0 3.882.583 3.882.583 1.843-.486 7.86-2.039.194-2.039Z",
    clipRule: "evenodd"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M145.2 101.681c.061 1.118-.375 2.08-.974 2.145-.599.067-1.135-.786-1.195-1.904-.062-1.119.272-1.99.865-2.128.593-.137 1.243.769 1.304 1.887Z",
    clipRule: "evenodd"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DEC1",
    fillRule: "evenodd",
    d: "m164.877 116.758.003 23.96 21.021-.002-.003-23.96-21.021.002Z",
    clipRule: "evenodd"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1AA8A",
    fillRule: "evenodd",
    d: "m149.635 116.76.003 23.96 15.877-.002-.003-23.96-15.877.002Z",
    clipRule: "evenodd"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#A86951",
    fillRule: "evenodd",
    d: "M156.377 119.816h2.587l-.001-3.057-2.586.001v3.056Z",
    clipRule: "evenodd"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m182.302 139.737 2.417-.001v-2.199l-2.417.001v2.199Z",
    clipRule: "evenodd"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#444441",
    fillRule: "evenodd",
    d: "M171.761 139.738h2.077v-2.2h-2.077v2.2ZM169.115 139.739l2.077-.001v-2.2h-2.077v2.201ZM166.551 139.739h2.077v-2.2h-2.077v2.2Z",
    clipRule: "evenodd"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0795F",
    fillRule: "evenodd",
    d: "M149.637 131.42v5.566l.1.032c.533.158 1.101.19 1.644.068l14.074-.012a1.844 1.844 0 0 0 1.793-1.888c-.028-1.015-5.75-1.82-6.764-1.792l-9.659.044-1.188-2.018ZM183.744 132.016c-.105.098-.165.195-.167.298a1.843 1.843 0 0 0 1.793 1.887h.529l.067-5.974c-1.428 0-2.587.335-2.6.787-.01.428.148.787.385 1.108-.337.172-.544.432-.55.622-.012.527.198.93.543 1.272Z",
    clipRule: "evenodd"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0795F",
    fillRule: "evenodd",
    d: "m149.539 133.845.699.84c.033-1.987.074 1.257.107 1.267.532.157 1.099.19 1.642.067l14.075-.011a1.844 1.844 0 0 0 1.792-1.889c-.027-1.014-5.749.182-6.764.209l-9.582.703-1.969-1.186Z",
    clipRule: "evenodd"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA68A",
    fillRule: "evenodd",
    d: "m141.428 118.639 3.116 5.551-.227 1.022 4.115 8.941c.42.753 1.165 1.303 1.992 1.55a3.27 3.27 0 0 0 1.643.068l4.988-.005 4.211-.005a1.841 1.841 0 0 0 1.792-1.887 1.841 1.841 0 0 0-1.888-1.793l-.3.002-2.26.01-7.099.03-4.036-8.808-.077-.136-2.759-6.34a1.841 1.841 0 0 0-3.211 1.8Z",
    clipRule: "evenodd"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "m158.245 135.766 3.667-.005c.164-.006.324-.033.475-.077-.196-.786-.578-2.275-.578-2.275s-.168-.784-.293-1.326l-2.26.01c-.598.328-.818 1.703-1.011 3.673ZM144.148 124.957l1.222 2.521.454 1.003.987-3.126 1.232-.763-.323-.748-.512-.657-.077-.137-.925.117-2.058 1.79Z",
    clipRule: "evenodd"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M145.733 118.03c.751 1.293 2.506 5.864 2.506 5.864l-5.088 3.033-1.716-3.724s-3.892-6.376.103-8.443c2.192-1.135 4.195 3.27 4.195 3.27Z",
    clipRule: "evenodd"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M159.141 133.721c0 1.42 1.245 2.574 2.766 2.563h.053c1.52-.012 2.765-1.184 2.765-2.605s-1.245-2.574-2.765-2.563l-.053.001c-1.521.011-2.766 1.183-2.766 2.604Z",
    clipRule: "evenodd"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M159.912 133.721c0 1.42 1.244 2.574 2.766 2.563h.052c1.521-.012 2.766-1.184 2.766-2.605s-1.245-2.574-2.766-2.563l-.052.001c-1.522.011-2.766 1.183-2.766 2.604Z",
    clipRule: "evenodd"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M165.465 131.986h1.823"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M163.027 131.986h2.24"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.566,
    d: "m161.183 132.221 1.125-1.564 2.719-.718"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M165.965 133.689h1.635"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M163.527 133.689h2.094"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M165.527 135.377h1.261"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M162.527 135.377H165.246"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M186.283 128.691h-1.604M186.773 130.394h-2.407M186.367 132.082h-1.688"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "m81.294 154.09-1.134 1.918s-.648-.973-1.945-.756c-1.297.215-6.59 1.674-6.59 1.674l-1.919-6.078 9.886-.891 1.702 4.133Z",
    clipRule: "evenodd"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M83.836 189.664c-.162 1.296-.513 2.661.135 3.39.648.73 1.864.54 2.54.054.675-.486.999-2.093.81-2.31-.19-.215-3.485-1.134-3.485-1.134Z",
    clipRule: "evenodd"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M90.235 189.742c-.104 1.899-1.602 1.866-3.482 1.866 0 .007.324.046.622.085-.2-.019-.472-.052-.823-.091-3.124-.356-3.513-.415-3.403-2.385.68-12.143.434-23.319-2.82-32.615a38.897 38.897 0 0 0-1.673-4.04c-.117-.245-.233-.491-.363-.732a4.347 4.347 0 0 0-.123-.246 3.57 3.57 0 0 1 1.517-4.81 3.542 3.542 0 0 1 2.982-.136h.006a3.547 3.547 0 0 1 1.822 1.653c1.368 2.632 2.45 5.419 3.3 8.311 3.1 10.599 3.034 22.547 2.438 33.14Z",
    clipRule: "evenodd"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M96.72 196.055c0 .563-.46 1.023-1.024 1.023H83.848c-.564 0-1.025-.46-1.025-1.023v-.275c0-.563.46-1.025 1.025-1.025h11.848c.564 0 1.025.462 1.025 1.025v.275Z",
    clipRule: "evenodd"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "m90.296 189.829-.6.05-1.62.131-.672.058s-.008.087-.043.224c-.109.543-.516 2.078-1.917 2.17-1.06.068-1.435-.542-1.69-.873-.232-.304-.516-.132-.611.12-.139.368-.33 1.273-.346 2.958v.159c0 .405.008.557.037 1.048.007.045 3.875 0 3.875 0s.702.116 1.605.253c.905.137 2.019.085 2.85.172 0 0 4.332.017 4.773-.02a.336.336 0 0 0 .087-.015c.014 0 .021-.007.028-.007l.066-.02c.007-.008.014-.008.021-.015a.185.185 0 0 0 .08-.044c.007 0 .007-.007.014-.007.022-.015.043-.029.057-.044.008-.007.023-.014.03-.021a.232.232 0 0 0 .043-.051l.022-.022a.426.426 0 0 0 .057-.072c.008-.014.015-.021.023-.036.014-.014.02-.029.036-.051a.665.665 0 0 0 .021-.043l.022-.043a.689.689 0 0 0 .05-.109c0-.007.008-.015.008-.029.007-.021.014-.043.029-.065 0-.008.007-.021.007-.036l.022-.065c0-.008.007-.021.007-.029.014-.065.03-.13.044-.203.029-.18.029-.39.029-.433v-.007c-.008-.029-.008-.058-.008-.088-.058-.751-.916-.962-1.793-.962-.893 0-1.83-.02-1.83-.02s-1.373-1.223-2.111-2.055l-.702-1.858Z",
    clipRule: "evenodd"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M54.362 188.375c1.212 3.676 4.288 10.122 7.516 8.91 2.043-.766 1.614-1.015 1.274-1.999-.503-1.454-1.122-2.54-1.122-2.54l-2.585-2.407.864-1.971-1.286-3.531s-2.526-.941-3.807.125c-1.285 1.068-1.262 2.172-.854 3.413Z",
    clipRule: "evenodd"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M55.15 187.8c1.17 3.69 4.781 9.765 7.131 9.238 1.732-.388 1.91-1.241 1.58-2.229-.486-1.458-1.094-2.552-1.094-2.552l-.123-.264-.93-2.626.62-1.54-2.484-3.511s-2.516-.97-3.81.081c-1.295 1.054-1.285 2.158-.89 3.403Z",
    clipRule: "evenodd"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M56.986 184.694c-.513.783-.647 1.836 0 2.566.649.729 1.864.541 2.54.054.675-.486-.082-1.998-.27-2.215-.19-.216-2.27-.405-2.27-.405Z",
    clipRule: "evenodd"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5785C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.438,
    d: "m82.322 118.169 2.838 14.038a1.844 1.844 0 0 0 2.063 1.437l6.28-.972"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB287",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m89.947 126.188 6.924 9.473 10.385 3.965"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#602C34",
    fillRule: "evenodd",
    d: "M71.176 144.557c-2.793 1.27-5.054 4.087-5.024 6.258.03 2.173 2.495 3.358 5.476 2.635l5.629-1.367c2.982-.723 5.417-3.826 5.413-6.894l-.001-.276c-.005-3.068-2.293-4.539-5.086-3.269l-6.407 2.913Z",
    clipRule: "evenodd"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "m80.801 125.811-.535-2.867a138.71 138.71 0 0 0-1.675-7.622l-.712-2.829s-1.94-1.922.743-1.922c3.179 0 5.246 2.785 7.014 5.17a224.194 224.194 0 0 0 4.815 6.231l-9.65 3.839Z",
    clipRule: "evenodd"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#D64404",
    fillRule: "evenodd",
    d: "m83.96 125.213-1.894-9.225-3.661 10.217 5.554-.992Z",
    clipRule: "evenodd"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M82.676 146.638v1.899c-.026.901-.383 1.77-.96 2.463-.629.779-1.53 1.337-2.522 1.485l-.537.078-5.576.843-2.372.357-.921.136h-.006l-.733.11c-1.498.22-2.457.959-2.846.35-.11-.176-.175-.454-.194-.875l-.072-.279c-.136-.558-.447-1.854-.538-2.84-.039-.434-.085-.914-.117-1.367 0-.014-.006-.026-.006-.046-.013-.143-.02-.272-.033-.402v-.071c-.051-.662-.084-1.154-.084-1.154l.04-.019 5.51-3.086 11.953-6.684v1.802l.007 1.42v.265l.007 5.615Z",
    clipRule: "evenodd"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M70.354 110.555h7.993c2.588.021 4.623 2.374 4.623 5.135 0 0-.486 23.304-.55 25.072-.007.183-.457.542-.457.542s1.206-.841-5.569-.787c-7.967.062-11.15 7.457-11.15 7.457v-32.429c0-2.761 2.522-5.011 5.11-4.99Z",
    clipRule: "evenodd"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#D64404",
    fillRule: "evenodd",
    d: "m69.895 117.411-.736-.181h-.197l-2.305 1.537-.769 9.582 1.184 2.756 5.55-2.124.272-7.412-3-4.158Z",
    clipRule: "evenodd"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M82.87 128.123s-.059 2.924-.123 7.623c-.026 1.499-.052 3.184-.078 5.012v.265c0 .073 0 .15-.007.228v.246s-5.218 4.156-9.944 6.794a38.14 38.14 0 0 1-2.01 1.031c-1.918.888-3.591 1.341-4.564.914a1.676 1.676 0 0 1-.291-.169v-.007c-.292-.22-.493-.57-.571-1.062 0-.014-.006-.027-.006-.046-.013-.143-.02-.272-.033-.402v-.071c0-.213-.018-.448-.039-.726-.006-.13-.006-.259-.006-.383v-.065c-.175-5.581.117-22.203.117-22.203l1.62.707v2.832s.87-.148 2.224-.148c.233 0 .447-.039.642-.104 2.729-.954 1.912-8.214 1.912-10.308h9.834c0 10.042.195 10.042 1.323 10.042Z",
    clipRule: "evenodd"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#751931",
    fillRule: "evenodd",
    d: "M73.114 154.041c.038.843.078 1.693.103 2.561 0 0-.025-1.463-.047-3.21l-.09.014c.014.207.02.421.034.635Z",
    clipRule: "evenodd"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M84.497 148.291a3.543 3.543 0 0 0-1.822-1.653l-.006-5.615v-.265c.026-1.828.052-3.513.078-5.012l-12.039.435-2.215 2.215s-1.33 1.535-1.087 1.31c1.25-1.148 2.64-.036 3.343 1.135 1.56 2.601 2.39 6.037 2.39 8.63 0 1.135.015 2.609.032 3.921l5.485-.829a38.701 38.701 0 0 1 1.672 4.039l6.119-3.984a43.456 43.456 0 0 0-1.95-4.327Z",
    clipRule: "evenodd"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M71.624 139.639c-1.016 0-1.04.62-1.729.108-1.89-1.405-4.696.564-4.696 5.294v-20.937l1.736 1.706v2.834s.868-.151 2.227-.151c.232 0 .441-.036.636-.102.29.543.47.905.47.905.177 6.432 11.759 2.142 11.759 4.083 0 4.245-3.849 6.26-10.403 6.26Z",
    clipRule: "evenodd"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DEC1",
    fillRule: "evenodd",
    d: "M74.762 134.264h32.688v-14.551H74.762v14.551Z",
    clipRule: "evenodd"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1AA8A",
    fillRule: "evenodd",
    d: "M74.763 133.376h23.176v-13.663H74.763v13.663Z",
    clipRule: "evenodd"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DEC1",
    fillRule: "evenodd",
    d: "M97.87 148.258h9.581v-14.551H97.87v14.551Z",
    clipRule: "evenodd"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1AA8A",
    fillRule: "evenodd",
    d: "M74.76 148.259h23.177v-14.554H74.76v14.554Z",
    clipRule: "evenodd"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#93652A",
    fillRule: "evenodd",
    d: "M84.076 145.581c0 .246-2.914 2.837-2.914 2.837l-6.402-4.931v-9.782l.648 1.422 2.594 4.542s6.074 5.666 6.074 5.912Z",
    clipRule: "evenodd"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E3925",
    fillRule: "evenodd",
    d: "M67.375 98.312c.281 3.923 1.25 4.981 2.783 4.981 1.258 0 2.3-1.735 2.255-2.141-.045-.406-.496-2.795-.856-2.93-.361-.136-4.182.09-4.182.09Z",
    clipRule: "evenodd"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E3925",
    fillRule: "evenodd",
    d: "M70.964 102.458c-.25-.501-.403 1.089-.407.899-.063-3.339-2.923-.852-3.149-4.55-.192-3.151-.219-3.18-.304-4.71-.169-3.044 1.599-6.273 8.103-6.223 3.62.028 4.55 1.434 5.366 3.278 1.52 3.435.293 7.847.293 7.847l-9.902 3.459Z",
    clipRule: "evenodd"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB287",
    fillRule: "evenodd",
    d: "M76.817 110.788s.05 1.284-2.043 1.284-3.397-1.284-3.397-1.284v-6.376l5.44-.3v6.676Z",
    clipRule: "evenodd"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M76.817 109.423c-1.425.175-5.4-.336-5.4-1.273 0-.936-.04-5.091-.04-5.091l5.44.037v6.327Z",
    clipRule: "evenodd"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M81.517 101.019c0 1.252-1.092 4.14-1.769 5.004-.29.369-.688 1.206-1.606 1.483-.835.253-1.328.432-1.328.883 0 .489-1.028-.459-1.378-.459-4.17 0-6.231-4.492-6.231-7.552l1.285-4.014c0-3.35 2.223-5.758 5.459-5.733 3.236.025 5.841 2.231 5.841 5.58l-.273 4.808Z",
    clipRule: "evenodd"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB287",
    fillRule: "evenodd",
    d: "m81.875 96.082-.044 1.33-.115 3.609c-.124 3.515-.912 6.761-5.178 6.725-4.26-.029-5.402-5.185-5.286-8.525l.202-2.907c0-.123 0-.247.008-.362.087-4.36 1.858-5.96 4.99-5.96 4.273 0 5.538 2.743 5.423 6.09Z",
    clipRule: "evenodd"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5785C",
    fillRule: "evenodd",
    d: "M78.08 101.828c.607.002 1.123-.342 1.097-.692-.01-.127-.138-.28-.376-.168-.108.051-.404.111-.718.109-.313-.002-.484-.065-.66-.118-.387-.116-.509.036-.519.164-.027.349.568.698 1.175.705ZM71.316 98.914c.088 1.248-.547 2.321-1.418 2.396-.872.074-1.65-.878-1.738-2.126-.09-1.249.397-2.22 1.26-2.375.862-.154 1.807.857 1.895 2.105Z",
    clipRule: "evenodd"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#422B27",
    fillRule: "evenodd",
    d: "M75.004 98.638c0 .297.242.54.542.541a.534.534 0 0 0 .541-.532.545.545 0 0 0-.541-.542.535.535 0 0 0-.542.533ZM79.785 98.721c0 .297.242.54.542.542a.534.534 0 0 0 .541-.533.544.544 0 0 0-.541-.541.534.534 0 0 0-.542.532Z",
    clipRule: "evenodd"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E3925",
    strokeLinecap: "round",
    strokeWidth: 1.379,
    d: "m74.064 96.434 2.437-.049M79.524 96.476l2.098.151"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E3925",
    fillRule: "evenodd",
    d: "M70.003 95.858c0-1.897.85-3.592 2.174-4.7-.638-.794-.87-1.98-.734-2.089.226-.18 3.148-2.352 6.597-.357 2.362 1.366 3.443 2.282 3.038 3.252l.017.033-.021-.02c-.365.86-1.177 1.42-1.898 1.42-3.02 0-2.957-1.773-5.208-1.6-.879.068-2.214.625-2.214 2.823 0 2.385-.39 4.87-.406 4.871-.706.046-.716-.413-.716-.413 0-1.263-.189-1.968-.992-2.345l.363-.875Z",
    clipRule: "evenodd"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5785C",
    strokeLinecap: "round",
    strokeWidth: 1.505,
    d: "M75.998 103.904c.82-.108 2.225-.391 2.922.002"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#602C34",
    fillRule: "evenodd",
    d: "m78.829 152.023-.001-.028v.028ZM78.926 152.876l-.01-.056.01.056ZM78.877 152.568l-.003-.025a.37.37 0 0 1 .003.025ZM78.848 152.309l-.004-.041.004.041Z",
    clipRule: "evenodd"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB287",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m70.216 126.188 3.902 9.378 9.913 12.556"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M70.486 110.555c-5.94 0-7.227 3.533-7.172 6.503.055 2.922 3.62 12.706 3.62 12.706l6.264-2.136-3.304-10.443.592-6.63Z",
    clipRule: "evenodd"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E17",
    fillRule: "evenodd",
    d: "M70.354 110.555c2.836 0 3.497 4.539 3.46 7.523l-.978 2.169-1.119-2.169c.037-2.984-.667-7.426-3.824-7.248 0 0 .706-.132 1.201-.204.496-.07 1.26-.071 1.26-.071ZM78.13 110.555s-.763-.074-1.26-.004l-.053.008v.229s.004.08-.025.203c2.205.811 2.734 4.497 2.701 7.087l1.216 1.446.842-1.446c.037-2.984-.585-7.523-3.42-7.523Z",
    clipRule: "evenodd"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#C67560",
    fillRule: "evenodd",
    d: "m81.875 96.082-.044 1.33c-.188-.932-3.089-1.125-6.285-1.003-1.91.08-3.87.218-3.935 1.004.087-4.36 1.71-7.42 4.84-7.42 4.274 0 5.54 2.742 5.424 6.089Z",
    clipRule: "evenodd"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M81.55 94.085c-.471-.362-.963-.18-3.145-.18-2.474 0-4.998.36-7.03.976-2.054.621-3.6 1.504-4.056 2.518-.213.157-.542-1.852-.574-3.297-.005-.08-.005-.156-.005-.232 0-.57.07-1.134.213-1.678.623-2.359 2.617-4.37 6.252-4.947.014 0 .028-.008.036-.008.406-.063.83-.108 1.28-.137.16-.01.313-.014.467-.014.951-.013 1.784.13 2.508.376.051.016.102.034.151.056 1.86.68 2.99 2.065 3.57 3.385.724 1.627.665 3.155.334 3.182Z",
    clipRule: "evenodd"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M84.007 93.271c-.75.037-1.586-.04-2.457-.013.266.845.36 1.806.325 2.824 5.55.278 6.712-3.032 2.132-2.81Z",
    clipRule: "evenodd"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA903",
    fillRule: "evenodd",
    d: "M67.319 97.4c.454-1.015 2.001-1.897 4.057-2.518 2.03-.616 4.555-.978 7.029-.978 2.182 0 2.673-.18 3.145.182.332-.028.391-1.554-.332-3.182-.582-1.32-1.711-2.706-3.571-3.385 1.579.975 1.733 3.533 1.84 4.34.122.916-2.443 1.1-6.415 2.077-3.972.978-5.702 2.466-5.753 3.463Z",
    clipRule: "evenodd"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M71.377 94.883c-.67-3.047-2.034-7.525 4.912-7.449 7.153.079 5.345 6.917 5.345 6.917l-10.257.532Z",
    clipRule: "evenodd"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E9",
    fillRule: "evenodd",
    d: "M85.288 93.314c-1.81-.045-2.424.819-6.227 2.057-2.885.94-5.695-.049-7.684-.488.68-.62 7.606-1.682 11.425-1.708.995-.007 2.32.114 2.486.139Z",
    clipRule: "evenodd"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D454",
    fillRule: "evenodd",
    d: "M63.046 187.233c-.694.953-1.29.894-2.386.894a3.554 3.554 0 0 1-2.107-.693c-1.588-1.16-2.418-2.827-1.251-4.415 9.407-12.835 9.056-20.518 8.687-28.654-.02-.382-.039-.771-.052-1.161a71.191 71.191 0 0 1-.084-3.144c-.006-.142-.006-.285-.006-.427a3.567 3.567 0 0 1 7.131 0 78.949 78.949 0 0 0 .103 3.773c.013.207.02.421.032.635.04.843.079 1.692.105 2.561.266 7.987-.338 17.225-10.172 30.631Z",
    clipRule: "evenodd"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#A86951",
    fillRule: "evenodd",
    d: "M84.748 122.016h2.93v-2.303h-2.93v2.303ZM87.678 136.008l-2.93.001v-2.304l2.93-.001v2.304Z",
    clipRule: "evenodd"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M82.22 147.351c-.402 1.363.466 2.822 1.928 3.241l.05.014c1.462.42 2.988-.351 3.39-1.714.402-1.363-.465-2.821-1.927-3.241l-.05-.015c-1.463-.42-2.988.352-3.39 1.715Z",
    clipRule: "evenodd"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M82.96 147.569c-.402 1.363.465 2.822 1.927 3.241l.05.014c1.463.42 2.988-.351 3.39-1.714.402-1.363-.465-2.821-1.927-3.241l-.05-.014c-1.463-.42-2.987.351-3.39 1.714Z",
    clipRule: "evenodd"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "m88.776 147.478 1.75.516"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "m86.439 146.788 2.148.633"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.566,
    d: "m84.603 146.49 1.522-1.18 2.812.08"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "m88.774 149.253 1.569.463"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "m86.436 148.563 2.008.593"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "m87.876 150.747 1.21.358"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEDEDE",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "m84.999 149.898 2.338.691.27.079"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E9",
    strokeLinecap: "round",
    strokeWidth: 3.566,
    d: "M109.173 137.639h-1.605M109.662 139.343h-2.406M109.256 141.031h-1.688"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    fillRule: "evenodd",
    d: "M270.001 179.285c.037-.178.063-.361.074-.546.01-.168.002-.336-.006-.503.799-1.368.976-3.109.237-4.575-.786-1.558-2.513-2.508-4.242-2.563-.407-.313-.853-.567-1.361-.709-.823-.227-1.62-.146-2.406.163-.222.087-.43.192-.636.304a2.194 2.194 0 0 0-1.103-.667c-.012-.004-.024-.004-.036-.007-1.608-1.805-4.142-2.842-6.51-2.205-2.453.66-3.729 2.873-3.593 5.035-2.835 1.221-5.107 3.314-5.021 6.134.034 1.12.521 2.071 1.269 2.82l-.002.008c-1.236 1.426-1.682 3.55-.625 5.283.878 1.44 2.433 2.104 3.974 2.053 1.929 1.941 4.73 2.496 7.174 1.654a5.607 5.607 0 0 0 2.308-.788c3.584 2.616 9.766 2.506 10.388-2.536.148-1.202-.118-2.136-.629-2.83 1.133-.469 1.793-1.593 1.891-2.807.086-1.054-.383-2.031-1.145-2.718ZM335.223 186.925a3.592 3.592 0 0 0-.669-.48c-.326-1.089-1.064-1.964-2.375-2.201-1.939-.351-3.532 1.024-4.296 2.714a5.411 5.411 0 0 0-1.413 1.268c-1.146 1.486-1.196 3.514.333 4.762 1.39 1.133 3.532 1.428 5.258 1.217.82-.1 1.556-.512 1.919-1.192.12-.057.248-.102.359-.169 2.088-1.236 2.785-4.177.884-5.919ZM304.895 184.986a4.679 4.679 0 0 0-.087-.647l-.015-.054a4.236 4.236 0 0 0-.244-.582 2.397 2.397 0 0 0-.682-.782 1.7 1.7 0 0 0-.163-.347c-.32-.497-.796-.934-1.391-1.069-.632-.145-1.21-.059-1.792.234l-.539.272c-.163-1.457-1.433-2.471-2.923-2.11-.991.241-1.652.831-2.036 1.618-.157-.025-.314-.035-.475-.025-.829-.73-2.09-.946-3.086.074-1.066 1.091-1.952 2.463-1.915 4.046a4.268 4.268 0 0 0 1.037 2.669c-.423 1.017-.414 2.207.125 3.183.485.876 1.425 1.467 2.415 1.583.733.248 1.523.15 2.189-.197a2.794 2.794 0 0 0 2.328 1.228c1.44.003 2.601-.798 3.29-1.895.204-.017.412-.054.625-.125a2.66 2.66 0 0 0 1.27-.914c1.108-.782 1.769-2.112 1.266-3.522a2.858 2.858 0 0 0-.223-.463c.078-.062.155-.126.209-.174l.042-.038a3.82 3.82 0 0 0 .381-.492l.031-.047c.121-.197.207-.424.27-.648.03-.105.046-.318.051-.352.003-.021.045-.246.045-.352a.867.867 0 0 0-.003-.072Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDepartingTruck);
export default __webpack_public_path__ + "static/media/illustration-departing-truck.3a387312f2a4ab2ab2eddbabab3d72c2.svg";
export { ForwardRef as ReactComponent };